var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenueCuate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.74,
    y: 298.61,
    width: 88.24,
    height: 122.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.47,
    y: 294.08,
    width: 96.79,
    height: 4.53,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.26,
    y: 294.08,
    width: 30.44,
    height: 4.53,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.98,
    y: 298.61,
    width: 29.9,
    height: 122.11,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.5,355.14H341.23V316H410.5Zm-69-.25h68.77V316.23H341.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 327.43,
    width: 13.48,
    height: 7.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,334.72H370.06v-6.83h13.73Zm-13.48-.25h13.23v-6.33H370.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.5,404.3H341.23V365.14H410.5Zm-69-.25h68.77V365.39H341.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 376.59,
    width: 13.48,
    height: 7.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,383.88H370.06v-6.83h13.73Zm-13.48-.25h13.23V377.3H370.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    width: 1,
    height: 92.13,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.39 122.97 114.81 128.62 55.97 128.62 53.4 122.97 78.46 105.63 92.33 105.63 117.39 122.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.07 88.92 92.33 105.63 78.46 105.63 76.72 88.92 94.07 88.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.38 122.97 114.81 128.63 55.97 128.63 53.4 122.97 117.38 122.97",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.58,
    width: 1,
    height: 73.88,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.08 104.72 183.5 110.38 124.66 110.38 122.09 104.72 147.15 87.38 161.02 87.38 186.08 104.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.76 70.67 161.02 87.38 147.15 87.38 145.41 70.67 162.76 70.67",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.07 104.72 183.5 110.38 124.66 110.38 122.09 104.72 186.07 104.72",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.27,147c-41.6,0-41.67,59.14,0,59.14S122.93,147,81.27,147Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,182.14c-2.22,10.18-10.66,19-25.3,19-34.57,0-34.52-49.09,0-49.09h.68c-32.49.59-32.33,47.08.64,47.08C96,199.15,104,191.37,106.56,182.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.51,158.53a1,1,0,0,1,1.08,1v1.64a15.55,15.55,0,0,1,8,2.88c.41.29.63.54.63,1a1.11,1.11,0,0,1-1.17,1,1.16,1.16,0,0,1-.81-.29,13.4,13.4,0,0,0-6.75-2.67v11.52c6.84,1.32,9.72,3.67,9.72,7.7,0,4.37-4,7.46-9.63,7.62v3.21a1.08,1.08,0,0,1-2.16,0v-3.25a17.77,17.77,0,0,1-10.12-4,1.06,1.06,0,0,1-.5-.87,1.13,1.13,0,0,1,1.13-1,1.23,1.23,0,0,1,.81.29A15.15,15.15,0,0,0,80.52,188V176.27c-6.75-1.36-9.54-3.62-9.54-7.74s4-7.33,9.45-7.45v-1.56A1.05,1.05,0,0,1,81.51,158.53Zm-1,15.64V162.93c-4.36.09-7.24,2.47-7.24,5.44C73.28,171.17,74.72,172.9,80.52,174.17Zm2,2.51v11.37c4.5-.08,7.43-2.47,7.43-5.6C89.93,179.61,88.35,177.88,82.5,176.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,260.43c-25.87,19.69,3.25,58,29.16,38.31S315.23,240.71,289.33,260.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,258.58c-24.66,18.77,4.47,57.11,29.16,38.31S316.44,239.79,291.76,258.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.06,269.92c3.7,7.59,3.05,17.11-5.62,23.72-20.49,15.6-44.67-16.22-24.21-31.8l.41-.29c-19,15,4.06,45.08,23.59,30.2C326.2,285.69,327.11,277,324.06,269.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.35,264a.8.8,0,0,1,1,.47l.47,1.26a10.84,10.84,0,0,1,6.41.12.93.93,0,0,1,.71.56.85.85,0,0,1-.53,1.08.81.81,0,0,1-.65,0,9.48,9.48,0,0,0-5.47-.28l3.27,8.79c5.15-.77,7.83.27,9,3.35,1.24,3.33-.68,6.73-4.56,8.31l.91,2.45a.8.8,0,1,1-1.5.56l-.93-2.48a12.57,12.57,0,0,1-8.2-.42.85.85,0,0,1-.59-.53.87.87,0,0,1,.49-1.07.82.82,0,0,1,.65,0,10.83,10.83,0,0,0,7.19.58l-3.33-9c-5.1.72-7.69-.28-8.85-3.43s.68-6.62,4.48-8.13l-.45-1.2A.81.81,0,0,1,301.35,264Zm3.75,12.19-3.19-8.57c-3,1.19-4.36,3.76-3.52,6S300.68,276.69,305.1,276.16Zm2.09,1.4,3.23,8.67c3.11-1.23,4.48-3.81,3.59-6.2C313.2,277.87,311.61,277,307.19,277.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.06,237.91c30.28,5.43,22.28,50.29-8.05,44.84S35.73,232.47,66.06,237.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22,237.4c28.85,5.18,20.85,50-8,44.84S34.31,232.21,63.22,237.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,260.88c.16,8,4.81,15.73,15,17.55,24,4.31,30.62-32.92,6.68-37.22l-.48-.07c22.46,4.49,16,39.72-6.84,35.62C45.89,275.08,41.39,268.19,40.89,260.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.89,244.48a.78.78,0,0,1,.61.89l-.24,1.25a10.31,10.31,0,0,1,5.15,3.21.88.88,0,0,1,.3.8.81.81,0,0,1-1,.63.85.85,0,0,1-.52-.32,9,9,0,0,0-4.3-2.9l-1.62,8.73c4.55,1.88,6.22,4,5.65,7.08-.62,3.31-3.83,5.13-7.75,4.53l-.45,2.43a.76.76,0,1,1-1.5-.28l.46-2.46a11.88,11.88,0,0,1-6.45-4.33.79.79,0,0,1-.22-.72.82.82,0,0,1,.92-.63.8.8,0,0,1,.52.32,10.26,10.26,0,0,0,5.55,4l1.66-8.89c-4.49-1.9-6.1-4-5.52-7.09s3.78-5,7.6-4.42l.22-1.19A.78.78,0,0,1,60.89,244.48ZM58,256.2l1.59-8.51c-3-.5-5.37.94-5.79,3.18S54.15,254.49,58,256.2Zm1,2.16L57.41,267c3.13.51,5.49-.92,5.93-3.29C63.75,261.53,62.9,260,59,258.36Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "44.66 420.76 95.99 420.51 147.33 420.43 250 420.26 352.67 420.43 404.01 420.51 455.34 420.76 404.01 421 352.67 421.09 250 421.26 147.33 421.09 95.99 421 44.66 420.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 455.47,
    rx: 173.02,
    ry: 16.97,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.36,
    y: 38.7,
    width: 257.79,
    height: 193.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.15,231.89l-257.79.27h-.27v-.27L201,38.7v-.37h.37l257.79.14h.23v.23Zm0,0L458.92,38.7l.23.23-257.79.15.37-.38-.1,193.19-.27-.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,125.74l102.6-.17c29.7.06,73.13,0,102.83.17-29.7.16-73.13.12-102.83.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,131.2l89.11-.18c29.7.07,86.62,0,116.32.18-29.7.15-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,136.66l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,142.12l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,147.57l89.11-.18c29.7.07,86.62,0,116.32.18-29.7.16-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,153l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,158.49l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,163.94l89.11-.17c29.7.06,86.62,0,116.32.17-29.7.16-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,169.4l89.11-.18c29.7.07,86.62,0,116.32.18-29.7.15-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,174.86l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,180.31l89.11-.17c29.7.06,86.62,0,116.32.17-29.7.16-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,185.77l89.11-.18c29.7.07,86.62,0,116.32.18-29.7.15-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,191.23l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,196.69l89.11-.18c29.7.06,86.62,0,116.32.18-29.7.15-86.62.11-116.32.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,202.14l89.11-.18c29.7.07,86.62,0,116.32.18-29.7.16-86.62.12-116.32.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.72,
    y: 186.64,
    width: 9.2,
    height: 21.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.37,
    y: 189.67,
    width: 9.2,
    height: 18.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.02,
    y: 182.56,
    width: 9.2,
    height: 25.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.66,
    y: 180.49,
    width: 9.2,
    height: 28.03,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.31,
    y: 169.4,
    width: 9.2,
    height: 39.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.96,
    y: 172.6,
    width: 9.2,
    height: 35.93,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.61,
    y: 165.55,
    width: 9.2,
    height: 42.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.26,
    y: 158.31,
    width: 9.2,
    height: 50.22,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.91,
    y: 158.61,
    width: 9.2,
    height: 49.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.56,
    y: 160.54,
    width: 9.2,
    height: 47.98,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.2,
    y: 150.8,
    width: 9.2,
    height: 57.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,121.91l.37,21.65.25,21.65c.17,14.43.22,28.86.26,43.29l-.88-.66,43.34,0,43.34.08,64.9.21,49,.39-49,.4-64.9.21-43.34.08-43.34,0h-.88v-.66c0-14.43.08-28.86.26-43.29l.25-21.65Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.36,
    y: 31.57,
    width: 257.79,
    height: 7.13,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,35.14a1.77,1.77,0,1,1-1.77-1.77A1.77,1.77,0,0,1,207,35.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,35.14a1.77,1.77,0,1,1-1.77-1.77A1.77,1.77,0,0,1,214.25,35.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.47,35.14a1.77,1.77,0,1,1-1.77-1.77A1.77,1.77,0,0,1,221.47,35.14Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.66,
    y: 59.96,
    width: 99.63,
    height: 50.6,
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,72.08a.43.43,0,0,1,.62-.06,2.82,2.82,0,0,0,1.65.66,1.87,1.87,0,0,0,1.08-.32.76.76,0,0,0,.37-.62.48.48,0,0,0-.08-.27.71.71,0,0,0-.26-.26,3.4,3.4,0,0,0-1.18-.41h0a5.15,5.15,0,0,1-1.11-.33,1.89,1.89,0,0,1-.8-.68,1.27,1.27,0,0,1-.2-.7,1.6,1.6,0,0,1,.69-1.26,2.58,2.58,0,0,1,1.49-.46,3.41,3.41,0,0,1,1.88.69.44.44,0,0,1,.12.61.43.43,0,0,1-.61.13,2.52,2.52,0,0,0-1.39-.55,1.66,1.66,0,0,0-1,.29.72.72,0,0,0-.33.55.45.45,0,0,0,.06.24.81.81,0,0,0,.23.22,2.86,2.86,0,0,0,1.08.38h0a5.55,5.55,0,0,1,1.19.36,2.1,2.1,0,0,1,.86.72,1.38,1.38,0,0,1,.21.73,1.66,1.66,0,0,1-.75,1.34,2.68,2.68,0,0,1-1.59.49,3.75,3.75,0,0,1-2.2-.86A.46.46,0,0,1,237,72.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.43,71.43v1.69a.46.46,0,0,1-.45.46.47.47,0,0,1-.45-.37,2,2,0,0,1-1.15.37,2,2,0,0,1-1.46-.63,2.25,2.25,0,0,1,0-3,2,2,0,0,1,1.46-.64,1.93,1.93,0,0,1,1.15.38.46.46,0,0,1,.45-.38.45.45,0,0,1,.45.46Zm-.91,0a1.31,1.31,0,0,0-.33-.89,1.08,1.08,0,0,0-.81-.35,1,1,0,0,0-.8.35,1.31,1.31,0,0,0-.32.89,1.34,1.34,0,0,0,.32.89,1.1,1.1,0,0,0,.8.33,1.14,1.14,0,0,0,.81-.33A1.35,1.35,0,0,0,245.52,71.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,67.55a.47.47,0,0,1,.48.47V73.1a.48.48,0,1,1-.95,0V68A.47.47,0,0,1,248.78,67.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48,71.42a2.13,2.13,0,0,1,2.1-2.15,2.06,2.06,0,0,1,2.08,2v0a.22.22,0,0,1,0,.08.42.42,0,0,1-.45.34h-2.74a1.09,1.09,0,0,0,.3.57,1.32,1.32,0,0,0,.82.39,1.43,1.43,0,0,0,.9-.22.48.48,0,0,1,.64,0,.39.39,0,0,1,0,.56,2.17,2.17,0,0,1-3.64-1.59Zm.94-.42h2.44a1.42,1.42,0,0,0-1.28-.91A1.2,1.2,0,0,0,251.42,71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,72.34a.46.46,0,0,1,.65-.07,1.56,1.56,0,0,0,.95.38,1.08,1.08,0,0,0,.58-.16.36.36,0,0,0,.16-.26.1.1,0,0,0,0-.08s0-.06-.11-.11a2.14,2.14,0,0,0-.69-.24h0a3.62,3.62,0,0,1-.75-.22,1.42,1.42,0,0,1-.59-.5,1,1,0,0,1-.15-.55,1.21,1.21,0,0,1,.51-.94,1.82,1.82,0,0,1,1.06-.32,2.17,2.17,0,0,1,1.29.47.48.48,0,0,1,.14.64.45.45,0,0,1-.64.12,1.45,1.45,0,0,0-.79-.32.89.89,0,0,0-.52.16.24.24,0,0,0-.13.19.13.13,0,0,0,0,.07.22.22,0,0,0,.1.09,1.8,1.8,0,0,0,.63.21h0a2.73,2.73,0,0,1,.81.25,1.33,1.33,0,0,1,.61.5,1.17,1.17,0,0,1,.16.57,1.24,1.24,0,0,1-.54,1,1.93,1.93,0,0,1-1.12.35,2.53,2.53,0,0,1-1.54-.6A.47.47,0,0,1,255.82,72.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,71.45v1.6a2.07,2.07,0,0,1-2.07,2.07,1.93,1.93,0,0,1-.9-.22.45.45,0,0,1-.21-.62.46.46,0,0,1,.62-.21,1.14,1.14,0,0,0,.49.12,1.16,1.16,0,0,0,1.13-.92,2,2,0,0,1-1.13.34,2,2,0,0,1-1.46-.65,2.18,2.18,0,0,1-.61-1.52,2.24,2.24,0,0,1,.61-1.53,2,2,0,0,1,2.62-.28.46.46,0,0,1,.91.09v1.72Zm-.92,0a1.34,1.34,0,0,0-.33-.88,1.07,1.07,0,0,0-.82-.37,1,1,0,0,0-.79.37,1.29,1.29,0,0,0,0,1.77,1.05,1.05,0,0,0,.79.35,1.09,1.09,0,0,0,.82-.35A1.32,1.32,0,0,0,265.79,71.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2,69.72a.46.46,0,0,1-.46.46.77.77,0,0,0-.51.17,1.21,1.21,0,0,0-.4.41,2.37,2.37,0,0,0-.35.72v1.64a.48.48,0,0,1-.48.46.46.46,0,0,1-.45-.46v-3.4a.44.44,0,0,1,.45-.44.46.46,0,0,1,.48.44v.07a1,1,0,0,1,.18-.18,1.85,1.85,0,0,1,1.08-.33A.44.44,0,0,1,271.2,69.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.51,73a2.16,2.16,0,0,1-.59-1.52,2.23,2.23,0,0,1,.59-1.51,2,2,0,0,1,1.48-.65,1.91,1.91,0,0,1,1.44.65,2.16,2.16,0,0,1,.61,1.51,2.1,2.1,0,0,1-.61,1.52,1.91,1.91,0,0,1-1.44.65A2,2,0,0,1,272.51,73Zm.35-1.52a1.37,1.37,0,0,0,.31.91,1.14,1.14,0,0,0,.82.32,1.13,1.13,0,0,0,.8-.32,1.41,1.41,0,0,0,0-1.81,1.19,1.19,0,0,0-1.62,0A1.38,1.38,0,0,0,272.86,71.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.7,70l-1.42,3.34,0,.07h0l0,.05h0a.1.1,0,0,1-.05,0s0,0,0,0l-.07,0h0l-.07,0h-.2l-.06,0h0a.25.25,0,0,1-.08-.05h0l-.05,0h0s0,0-.05-.05h0l0-.07-.63-1.49-.61,1.49a.43.43,0,0,0,0,.07h0l-.06.05h0l-.06,0-.07.05h0l-.05,0h-.22l-.05,0h0s-.06,0-.07-.05h0l0,0h0l0-.05h0l-.05-.07L277,70a.46.46,0,0,1,.25-.6.43.43,0,0,1,.57.26l1,2.32.6-1.44a.47.47,0,0,1,.42-.28.45.45,0,0,1,.42.28l.61,1.44,1-2.32a.44.44,0,0,1,.58-.26A.46.46,0,0,1,282.7,70Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.52,69.74a.49.49,0,0,1-.48.48h-.22v2.4a.47.47,0,0,1,.47.48.47.47,0,0,1-.47.48,1,1,0,0,1-1-1v-2.4h-.25a.48.48,0,0,1-.47-.48.46.46,0,0,1,.47-.47h.25V68a.47.47,0,0,1,.49-.47.46.46,0,0,1,.47.47v1.25H286A.48.48,0,0,1,286.52,69.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.81,73.1a.47.47,0,0,1-.48.48.49.49,0,0,1-.46-.36.37.37,0,0,1,0-.12V68a.47.47,0,0,1,.48-.47.47.47,0,0,1,.48.47v1.5a2,2,0,0,1,.92-.25,1.88,1.88,0,0,1,1.88,1.89V73.1a.47.47,0,0,1-.47.48.47.47,0,0,1-.48-.48V71.16a.94.94,0,0,0-.93-.94,1,1,0,0,0-.92.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,94.05a1.16,1.16,0,0,1-1.18,1.15h-.21v1.6a1.16,1.16,0,1,1-2.32,0V95.2h-6.63a1,1,0,0,1-.72-.25,1.12,1.12,0,0,1-.19-1.62L277,83.64s0,0,.05,0a.23.23,0,0,0,.06-.09.21.21,0,0,0,.1-.06l.09-.06a.21.21,0,0,1,.12,0s.05-.07.09-.07.06,0,.12,0a.13.13,0,0,0,.09,0h.36a.18.18,0,0,0,.1,0s.09,0,.13,0l.08,0,.11.09.1.06s0,0,0,0,.06,0,.06,0l.08.09a.5.5,0,0,0,.07.08l.08.11a.15.15,0,0,0,0,.08,1,1,0,0,1,0,.13s0,.06,0,.08a.25.25,0,0,1,0,.13s0,.06,0,.1v8.58h.21A1.17,1.17,0,0,1,280.49,94.05Zm-3.71-6.37-4.19,5.21h4.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,89a5.13,5.13,0,0,1,1.54,3.71A5.26,5.26,0,0,1,291,96.43,5.15,5.15,0,0,1,287.29,98h-.05a5.1,5.1,0,0,1-3.66-1.53,1.17,1.17,0,0,1,0-1.69,1.21,1.21,0,0,1,1.69,0,2.73,2.73,0,0,0,2,.84,2.78,2.78,0,0,0,2-.84,2.84,2.84,0,0,0,.84-2,2.83,2.83,0,0,0-2.84-2.84,2.77,2.77,0,0,0-2,.82,1.21,1.21,0,0,1-1.69,0l-.23-.28s0-.06,0-.06a.15.15,0,0,0,0-.1,1.3,1.3,0,0,0,0-.15s0,0,0,0a1.08,1.08,0,0,1,0-.36l.64-5.46a1.26,1.26,0,0,1,.52-.84l.09,0,.06,0a1.12,1.12,0,0,1,.55-.13h6.21a1.19,1.19,0,1,1,0,2.38h-5.18l-.25,2.08a5.63,5.63,0,0,1,1.41-.19A5.16,5.16,0,0,1,291,89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.73,86.86v0a3.56,3.56,0,0,1,3.5-3.77,3.51,3.51,0,0,1,3.45,3.73v0a3.56,3.56,0,0,1-3.5,3.77A3.52,3.52,0,0,1,295.73,86.86Zm5.08,0v0c0-1.18-.68-2.15-1.63-2.15s-1.58,1-1.58,2.11v0c0,1.2.68,2.15,1.63,2.15S300.81,88,300.81,86.86Zm-2.66,9.84,9.67-13.21a.81.81,0,0,1,.72-.38.83.83,0,0,1,.84.83,1,1,0,0,1-.19.54l-9.67,13.21a.87.87,0,0,1-.74.38.81.81,0,0,1-.82-.82A1,1,0,0,1,298.15,96.7Zm6.49-2.3v0a3.49,3.49,0,1,1,6.95,0v0a3.57,3.57,0,0,1-3.5,3.77A3.52,3.52,0,0,1,304.64,94.4Zm5.07,0v0c0-1.18-.67-2.15-1.62-2.15s-1.58,1-1.58,2.11v0c0,1.2.68,2.15,1.63,2.15S309.71,95.54,309.71,94.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,91a12.53,12.53,0,1,1-1.66-6.23A12.54,12.54,0,0,1,261.93,91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,91a12.54,12.54,0,0,1-8.05,11.71L249.39,91V78.46A12.53,12.53,0,0,1,261.93,91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,91a8.67,8.67,0,1,1-8.67-8.67A8.67,8.67,0,0,1,258.06,91Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.29,
    y: 70.5,
    width: 3.46,
    height: 3.08,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.77 70.5 303.28 70.5 300.02 67.06 296.77 70.5",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.22,
    y: 59.96,
    width: 99.63,
    height: 50.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,65.36a.45.45,0,0,1,.46.46v.24a3.88,3.88,0,0,1,1.67.59.58.58,0,0,1,.32.52.59.59,0,0,1-.6.59.55.55,0,0,1-.32-.1,4.34,4.34,0,0,0-1.11-.47v2.07c1.63.41,2.33,1.06,2.33,2.22s-.92,2-2.29,2.1v.64a.46.46,0,0,1-.46.47.48.48,0,0,1-.48-.47v-.67a4.5,4.5,0,0,1-2.2-.84.57.57,0,0,1-.3-.51.6.6,0,0,1,.95-.48,3.81,3.81,0,0,0,1.6.73V70.32c-1.58-.41-2.31-1-2.31-2.21a2.17,2.17,0,0,1,2.26-2.06v-.23A.47.47,0,0,1,345,65.36ZM344.56,69v-1.9c-.69.06-1,.43-1,.9S343.73,68.76,344.56,69Zm.85,1.5v2c.69-.08,1.06-.42,1.06-.94S346.24,70.79,345.41,70.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,73a.59.59,0,0,1-.59.6h-3.84a.59.59,0,0,1-.44-.2.6.6,0,0,1,0-.84l3.19-2.88a1.37,1.37,0,0,0,.45-1,1.4,1.4,0,0,0-.35-.93,1.36,1.36,0,0,0-1-.46,1.4,1.4,0,0,0-.93.36l-.34.3a.59.59,0,0,1-.84,0,.6.6,0,0,1,.05-.84l.33-.3a2.5,2.5,0,0,1,1.73-.67,2.6,2.6,0,0,1,1.92.85,2.55,2.55,0,0,1,.67,1.73,2.6,2.6,0,0,1-.85,1.92l-2,1.84h2.3A.59.59,0,0,1,357,73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,72.05a.8.8,0,1,1,0,1.6.8.8,0,0,1,0-1.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,66.63V73a.6.6,0,0,1-.61.6.59.59,0,0,1-.59-.6V67.69l-.43.24a.5.5,0,0,1-.3.09.6.6,0,0,1-.51-.3.58.58,0,0,1,.2-.81l1.32-.79,0,0s0,0,.06,0h.34a.12.12,0,0,1,.07,0h0s0,0,.07,0l0,0,0,0s0,0,0,0a.08.08,0,0,1,0,0l0,0v0s0,0,0,0,0,0,0,0,0,0,0,.06,0,0,0,0a.11.11,0,0,0,0,.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,69.81a4.66,4.66,0,0,1,.73-2.58,2.41,2.41,0,0,1,2-1.19,2.45,2.45,0,0,1,2,1.19,5,5,0,0,1,0,5.15,2.49,2.49,0,0,1-2,1.2,2.45,2.45,0,0,1-2-1.2A4.65,4.65,0,0,1,364,69.81Zm4.25,0a3.49,3.49,0,0,0-.52-1.92,1.25,1.25,0,0,0-1-.66,1.3,1.3,0,0,0-1,.66,3.58,3.58,0,0,0-.52,1.92,3.53,3.53,0,0,0,.52,1.9,1.3,1.3,0,0,0,1,.67,1.24,1.24,0,0,0,1-.67A3.45,3.45,0,0,0,368.26,69.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.42,73a.59.59,0,0,1-.59.6H372a.59.59,0,0,1-.44-.2.6.6,0,0,1,0-.84l3.19-2.88a1.37,1.37,0,0,0,.45-1,1.4,1.4,0,0,0-.35-.93,1.36,1.36,0,0,0-1-.46,1.4,1.4,0,0,0-.93.36l-.34.3a.59.59,0,0,1-.84,0,.6.6,0,0,1,0-.84l.33-.3a2.5,2.5,0,0,1,1.73-.67,2.6,2.6,0,0,1,1.92.85,2.55,2.55,0,0,1,.67,1.73,2.6,2.6,0,0,1-.85,1.92l-2,1.84h2.3A.59.59,0,0,1,376.42,73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,74.55a.94.94,0,0,0,.73-1,.8.8,0,0,1-.62-.74v-.08a.7.7,0,0,1,.74-.72c.48,0,.77.36.77.94v.12a2.11,2.11,0,0,1-.53,1.57,1.64,1.64,0,0,1-1,.47.3.3,0,0,1-.08-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,71a2.57,2.57,0,1,1-4-2.14,1.73,1.73,0,0,1-.36-1.07,1.78,1.78,0,0,1,3.56,0,1.73,1.73,0,0,1-.36,1.07A2.58,2.58,0,0,1,385.42,71Zm-1.17,0a1.4,1.4,0,0,0-1.39-1.4,1.43,1.43,0,0,0-1.41,1.4,1.41,1.41,0,0,0,1.41,1.39A1.39,1.39,0,0,0,384.25,71Zm-2-3.21a.6.6,0,1,0,1.2,0,.6.6,0,0,0-1.2,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.41,71a2.62,2.62,0,0,1-5.22.27v0c0-.21,0-.41,0-.62a6.25,6.25,0,0,1,.38-2.2,3.82,3.82,0,0,1,1.39-1.85,3.07,3.07,0,0,1,1.61-.5.6.6,0,0,1,.63.57.62.62,0,0,1-.58.62,1.92,1.92,0,0,0-1,.31,2.23,2.23,0,0,0-.67.75,1.47,1.47,0,0,0-.14.28,2.5,2.5,0,0,1,1-.22A2.62,2.62,0,0,1,392.41,71Zm-1.2,0a1.42,1.42,0,1,0-2.83,0,1.42,1.42,0,0,0,2.83,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,91a.46.46,0,0,1,.46.46v.24a4,4,0,0,1,1.67.59.58.58,0,0,1,.32.52.59.59,0,0,1-.6.59.62.62,0,0,1-.32-.09,4.06,4.06,0,0,0-1.11-.48v2.07c1.63.41,2.33,1.07,2.33,2.22s-.92,2-2.29,2.1v.64a.46.46,0,0,1-.46.47.48.48,0,0,1-.48-.47v-.66a4.71,4.71,0,0,1-2.2-.84.59.59,0,0,1,.3-1.11.53.53,0,0,1,.35.12,3.92,3.92,0,0,0,1.6.72V96c-1.58-.41-2.31-1-2.31-2.22a2.17,2.17,0,0,1,2.26-2.06v-.23A.48.48,0,0,1,345,91Zm-.43,3.67v-1.9c-.69.06-1,.43-1,.9S343.73,94.39,344.56,94.66Zm.85,1.5v2c.69-.07,1.06-.42,1.06-.94S346.24,96.42,345.41,96.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.34,92.26v6.36a.6.6,0,0,1-.6.59.59.59,0,0,1-.6-.59v-5.3l-.43.25a.54.54,0,0,1-.3.08.61.61,0,0,1-.31-1.11l1.32-.78s0,0,.05,0,0,0,0,0h.35l.06,0h0s0,0,.07,0l0,0,0,0a.11.11,0,0,1,.05,0,.11.11,0,0,1,0,.05l0,0v0s0,0,0,0a.09.09,0,0,1,0,.06s0,0,0,0a.43.43,0,0,0,0,.05s0,.06,0,.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.69,97.68a.82.82,0,0,1,.81.81.8.8,0,0,1-.81.79.79.79,0,0,1-.8-.79A.81.81,0,0,1,356.69,97.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,97.21a.59.59,0,0,1-.6.59h-.11v.82a.6.6,0,0,1-1.19,0V97.8h-3.39a.49.49,0,0,1-.36-.13.57.57,0,0,1-.1-.83l4-5s0,0,0,0l0,0,.05,0,0,0s0,0,.07,0,0,0,0,0l.07,0h.28l.06,0h0l.05.05.05,0h0l0,0,0,0,0,0,0,0a.05.05,0,0,0,0,0l0,.07s0,0,0,0a.13.13,0,0,1,0,.07s0,0,0,0v4.38h.11A.6.6,0,0,1,364,97.21ZM362.05,94l-2.14,2.66h2.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.32,94.64a2.68,2.68,0,0,1,0,3.78,2.64,2.64,0,0,1-1.89.79h0a2.58,2.58,0,0,1-1.87-.79.59.59,0,0,1,0-.86.6.6,0,0,1,.86,0,1.4,1.4,0,0,0,1,.43,1.43,1.43,0,0,0,1-.43,1.47,1.47,0,0,0,.43-1,1.42,1.42,0,0,0-.43-1,1.4,1.4,0,0,0-1-.42,1.44,1.44,0,0,0-1,.42.6.6,0,0,1-.86,0,.81.81,0,0,1-.12-.14s0,0,0,0a.08.08,0,0,0,0,0s0-.06,0-.08,0,0,0,0a.54.54,0,0,1,0-.18l.33-2.79a.64.64,0,0,1,.27-.43l0,0,0,0a.64.64,0,0,1,.28-.06h3.18a.61.61,0,0,1,.61.61.61.61,0,0,1-.61.61h-2.65L366.71,94a3,3,0,0,1,.72-.09A2.63,2.63,0,0,1,369.32,94.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.86,95.44a4.6,4.6,0,0,1,.73-2.57,2.27,2.27,0,0,1,4,0,4.6,4.6,0,0,1,.72,2.57,4.65,4.65,0,0,1-.72,2.57,2.27,2.27,0,0,1-4,0A4.65,4.65,0,0,1,371.86,95.44Zm4.26,0a3.6,3.6,0,0,0-.52-1.92,1.22,1.22,0,0,0-1-.65,1.28,1.28,0,0,0-1,.65,3.85,3.85,0,0,0,0,3.83,1.32,1.32,0,0,0,1,.66,1.26,1.26,0,0,0,1-.66A3.59,3.59,0,0,0,376.12,95.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.43,100.18a.94.94,0,0,0,.73-1,.8.8,0,0,1-.62-.73v-.09a.7.7,0,0,1,.74-.72c.48,0,.77.36.77,1v.11a2.13,2.13,0,0,1-.53,1.58,1.63,1.63,0,0,1-1,.46.3.3,0,0,1-.08-.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.64,98.62a.58.58,0,0,1-.59.59h-3.83a.62.62,0,0,1-.45-.19.61.61,0,0,1,0-.85L385,95.29a1.34,1.34,0,0,0,.46-1,1.38,1.38,0,0,0-1.39-1.38,1.39,1.39,0,0,0-.94.35l-.33.3a.58.58,0,0,1-.84,0,.59.59,0,0,1,0-.84l.33-.3a2.57,2.57,0,0,1,1.74-.67,2.6,2.6,0,0,1,1.92.85,2.55,2.55,0,0,1,.66,1.73,2.59,2.59,0,0,1-.85,1.92l-2,1.84h2.29A.6.6,0,0,1,386.64,98.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.11,94.64a2.68,2.68,0,0,1,0,3.78,2.64,2.64,0,0,1-1.89.79h0a2.58,2.58,0,0,1-1.87-.79.59.59,0,0,1,0-.86.6.6,0,0,1,.86,0,1.4,1.4,0,0,0,1,.43,1.43,1.43,0,0,0,1-.43,1.51,1.51,0,0,0,.43-1,1.42,1.42,0,0,0-.43-1,1.4,1.4,0,0,0-1-.42,1.44,1.44,0,0,0-1,.42.6.6,0,0,1-.86,0,.81.81,0,0,1-.12-.14s0,0,0,0a.08.08,0,0,0,0,0s0-.06,0-.08,0,0,0,0a.54.54,0,0,1,0-.18l.33-2.79a.64.64,0,0,1,.27-.43l0,0,0,0a.64.64,0,0,1,.28-.06h3.18a.61.61,0,0,1,.61.61.61.61,0,0,1-.61.61h-2.65L389.5,94a3,3,0,0,1,.72-.09A2.63,2.63,0,0,1,392.11,94.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.47,78.25a2,2,0,0,1,2-1.94,2,2,0,0,1,1.24.42.33.33,0,0,1,.06.43.32.32,0,0,1-.44.06,1.33,1.33,0,0,0-.86-.29,1.43,1.43,0,0,0-1,.38,1.32,1.32,0,0,0-.4.94,1.29,1.29,0,0,0,.4.94,1.39,1.39,0,0,0,1,.39,1.31,1.31,0,0,0,.86-.3.34.34,0,0,1,.44.06.32.32,0,0,1-.06.43,2,2,0,0,1-3.22-1.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.8,80.19a1.13,1.13,0,0,1-1.13-1.12V77.78a.29.29,0,0,1,.58,0v1.29a.54.54,0,0,0,.55.55.55.55,0,0,0,.56-.55V77.78a.28.28,0,0,1,.28-.28.3.3,0,0,1,.29.28v1.29A1.13,1.13,0,0,1,368.8,80.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.69,77.78a.29.29,0,0,1-.28.29.52.52,0,0,0-.33.1,1,1,0,0,0-.25.26,1.76,1.76,0,0,0-.22.45v1a.29.29,0,0,1-.58,0V77.78a.29.29,0,0,1,.58,0v0l.12-.11a1.19,1.19,0,0,1,.68-.21A.28.28,0,0,1,372.69,77.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.06,77.78a.3.3,0,0,1-.29.29.51.51,0,0,0-.32.1.88.88,0,0,0-.25.26,1.76,1.76,0,0,0-.22.45v1a.3.3,0,0,1-.3.28.29.29,0,0,1-.28-.28V77.78a.29.29,0,0,1,.28-.28.3.3,0,0,1,.3.28v0a.57.57,0,0,1,.11-.11,1.22,1.22,0,0,1,.68-.21A.29.29,0,0,1,375.06,77.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,78.85a1.34,1.34,0,0,1,1.32-1.35,1.29,1.29,0,0,1,1.3,1.25v0a.06.06,0,0,1,0,0,.26.26,0,0,1-.28.22h-1.71a.69.69,0,0,0,.18.36.84.84,0,0,0,.52.24.89.89,0,0,0,.56-.14.3.3,0,0,1,.4,0,.24.24,0,0,1,0,.35,1.35,1.35,0,0,1-1,.35A1.34,1.34,0,0,1,375.3,78.85Zm.59-.27h1.53a.9.9,0,0,0-.8-.57A.75.75,0,0,0,375.89,78.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,78.62v1.29a.28.28,0,0,1-.28.28.29.29,0,0,1-.28-.28V78.62a.57.57,0,0,0-.57-.55.55.55,0,0,0-.54.55v1.29a.11.11,0,0,1,0,0,.28.28,0,0,1-.28.23.29.29,0,0,1-.29-.28V77.78a.29.29,0,0,1,.29-.28.28.28,0,0,1,.26.17,1,1,0,0,1,.57-.17A1.13,1.13,0,0,1,381,78.62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,77.79a.3.3,0,0,1-.3.3h-.14V79.6a.3.3,0,1,1,0,.59.6.6,0,0,1-.6-.59V78.09h-.15a.3.3,0,1,1,0-.59h.15v-.78a.3.3,0,0,1,.31-.3.29.29,0,0,1,.29.3v.78H383A.3.3,0,0,1,383.29,77.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.17,78.73h-.67V79.9a.3.3,0,0,1-.59,0V76.72a.29.29,0,0,1,.29-.3h1a1.16,1.16,0,1,1,0,2.31Zm-.67-.6h.67a.56.56,0,1,0,0-1.11h-.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.74,78.85a1.34,1.34,0,0,1,1.32-1.35,1.29,1.29,0,0,1,1.3,1.25v.07a.27.27,0,0,1-.29.22h-1.71a.82.82,0,0,0,1.26.46.32.32,0,0,1,.41,0,.25.25,0,0,1,0,.35,1.4,1.4,0,0,1-1,.35A1.34,1.34,0,0,1,388.74,78.85Zm.59-.27h1.53a.89.89,0,0,0-.8-.57A.76.76,0,0,0,389.33,78.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.76,77.78a.29.29,0,0,1-.28.29.52.52,0,0,0-.33.1,1,1,0,0,0-.25.26,1.76,1.76,0,0,0-.22.45v1a.29.29,0,0,1-.58,0V77.78a.29.29,0,0,1,.58,0v0l.12-.11a1.19,1.19,0,0,1,.68-.21A.28.28,0,0,1,393.76,77.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,76.82a.29.29,0,0,1-.29.3.29.29,0,0,1-.29-.3v-.11a.29.29,0,0,1,.29-.29.28.28,0,0,1,.29.29Zm0,1v2.1a.28.28,0,0,1-.29.29.29.29,0,0,1-.29-.29V77.8a.29.29,0,0,1,.29-.3A.29.29,0,0,1,395.05,77.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,79.8a1.36,1.36,0,0,1-.37-1,1.39,1.39,0,0,1,.37-.94,1.22,1.22,0,0,1,.93-.41,1.18,1.18,0,0,1,.9.41,1.34,1.34,0,0,1,.37.94,1.31,1.31,0,0,1-.37,1,1.21,1.21,0,0,1-.9.41A1.26,1.26,0,0,1,396.23,79.8Zm.21-1a.84.84,0,0,0,.2.57.72.72,0,0,0,.52.2.7.7,0,0,0,.49-.2.87.87,0,0,0,0-1.13.74.74,0,0,0-.49-.2.76.76,0,0,0-.52.2A.83.83,0,0,0,396.44,78.85Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79,79.9a.29.29,0,0,1-.58.06,1.29,1.29,0,0,1-.73.23,1.35,1.35,0,0,1,0-2.69,1.28,1.28,0,0,1,.72.22v-1a.3.3,0,0,1,.59,0v2.14h0Zm-1.31-1.81a.7.7,0,0,0-.51.22.77.77,0,0,0-.21.54.79.79,0,0,0,.21.54.7.7,0,0,0,1,0,.79.79,0,0,0,.21-.54.77.77,0,0,0-.21-.54A.7.7,0,0,0,400.48,78.09Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,103.93h-.67v1.17a.29.29,0,0,1-.3.3.3.3,0,0,1-.3-.3v-3.18a.29.29,0,0,1,.3-.29h1a1.15,1.15,0,1,1,0,2.3Zm-.67-.6h.67a.56.56,0,0,0,.56-.55.57.57,0,0,0-.56-.56h-.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.38,103a.29.29,0,0,1-.29.28.52.52,0,0,0-.32.11.63.63,0,0,0-.25.26,1.61,1.61,0,0,0-.22.45v1a.3.3,0,0,1-.3.29.29.29,0,0,1-.28-.29V103a.28.28,0,0,1,.28-.28.29.29,0,0,1,.3.28v0a.57.57,0,0,1,.11-.11,1.15,1.15,0,0,1,.68-.21A.28.28,0,0,1,368.38,103Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.62,104.05a1.34,1.34,0,0,1,1.32-1.35,1.29,1.29,0,0,1,1.3,1.25v0s0,0,0,0a.26.26,0,0,1-.28.22h-1.71a.62.62,0,0,0,.18.35.79.79,0,0,0,.52.24.88.88,0,0,0,.56-.13.31.31,0,0,1,.4,0,.24.24,0,0,1,0,.35,1.32,1.32,0,0,1-1,.36A1.35,1.35,0,0,1,368.62,104.05Zm.59-.26h1.53a.87.87,0,0,0-.8-.57A.75.75,0,0,0,369.21,103.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,103.14l-.89,2.09a.08.08,0,0,1,0,0h0l0,0h0l0,0h0l0,0h-.23l-.05,0h0l0,0h0a.08.08,0,0,0,0,0h0s0,0,0,0l-.87-2.09a.27.27,0,0,1,.15-.37.27.27,0,0,1,.36.15l.62,1.47.63-1.47a.27.27,0,0,1,.36-.15A.28.28,0,0,1,374.09,103.14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.68,102a.29.29,0,0,1-.29.3.3.3,0,0,1-.29-.3v-.11a.28.28,0,0,1,.29-.29.28.28,0,0,1,.29.29Zm0,1v2.1a.28.28,0,0,1-.29.29.29.29,0,0,1-.29-.29V103a.29.29,0,0,1,.29-.3A.28.28,0,0,1,375.68,103Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,105a1.37,1.37,0,0,1-.37-1,1.41,1.41,0,0,1,.37-1,1.29,1.29,0,0,1,.93-.41,1.19,1.19,0,0,1,.9.41,1.33,1.33,0,0,1,.38,1,1.3,1.3,0,0,1-.38,1,1.19,1.19,0,0,1-.9.41A1.29,1.29,0,0,1,376.85,105Zm.22-1a.89.89,0,0,0,.19.57.75.75,0,0,0,.52.2.72.72,0,0,0,.5-.2.85.85,0,0,0,.21-.57.82.82,0,0,0-.21-.56.78.78,0,0,0-.5-.21.81.81,0,0,0-.52.21A.86.86,0,0,0,377.07,104.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,105.4a1.13,1.13,0,0,1-1.12-1.12V103a.29.29,0,1,1,.58,0v1.29a.54.54,0,0,0,.54.55.55.55,0,0,0,.57-.55V103a.29.29,0,0,1,.28-.29.3.3,0,0,1,.29.29v1.29A1.14,1.14,0,0,1,381,105.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,104.63a.28.28,0,0,1,.41,0,1,1,0,0,0,.59.23.81.81,0,0,0,.37-.1.22.22,0,0,0,.09-.16s0,0,0,0a.22.22,0,0,0-.07-.07,1.48,1.48,0,0,0-.43-.15h0a2.15,2.15,0,0,1-.47-.14.92.92,0,0,1-.37-.31.67.67,0,0,1-.09-.34.79.79,0,0,1,.31-.6,1.18,1.18,0,0,1,.67-.2,1.41,1.41,0,0,1,.81.3.3.3,0,0,1,.08.4.29.29,0,0,1-.4.08.88.88,0,0,0-.49-.21.61.61,0,0,0-.33.1.16.16,0,0,0-.08.13.06.06,0,0,0,0,0s0,0,.06,0a1,1,0,0,0,.39.13h0a1.94,1.94,0,0,1,.5.15.87.87,0,0,1,.39.32.75.75,0,0,1,.1.36.78.78,0,0,1-.34.62,1.19,1.19,0,0,1-.7.22,1.62,1.62,0,0,1-1-.37A.29.29,0,0,1,383.06,104.63Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.78,103.93h-.66v1.17a.3.3,0,0,1-.31.3.29.29,0,0,1-.29-.3v-3.18a.28.28,0,0,1,.29-.29h1a1.15,1.15,0,1,1,0,2.3Zm-.66-.6h.66a.56.56,0,0,0,.56-.55.57.57,0,0,0-.56-.56h-.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,104.05a1.34,1.34,0,0,1,1.32-1.35A1.29,1.29,0,0,1,393,104V104a.27.27,0,0,1-.29.22H391a.78.78,0,0,0,.18.35.82.82,0,0,0,.52.24.87.87,0,0,0,.56-.13.32.32,0,0,1,.41,0,.25.25,0,0,1,0,.35,1.37,1.37,0,0,1-2.29-1Zm.59-.26h1.53a.86.86,0,0,0-.8-.57A.76.76,0,0,0,390.94,103.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.37,103a.28.28,0,0,1-.28.28.55.55,0,0,0-.33.11.67.67,0,0,0-.24.26,1.72,1.72,0,0,0-.23.45v1a.29.29,0,1,1-.58,0V103a.29.29,0,0,1,.58,0v0l.12-.11a1.15,1.15,0,0,1,.68-.21A.27.27,0,0,1,395.37,103Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,102a.3.3,0,1,1-.59,0v-.11a.3.3,0,0,1,.59,0Zm0,1v2.1a.3.3,0,0,1-.59,0V103a.3.3,0,1,1,.59,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.84,105a1.37,1.37,0,0,1-.37-1,1.41,1.41,0,0,1,.37-1,1.26,1.26,0,0,1,.93-.41,1.21,1.21,0,0,1,.9.41,1.36,1.36,0,0,1,.37,1,1.33,1.33,0,0,1-.37,1,1.21,1.21,0,0,1-.9.41A1.26,1.26,0,0,1,397.84,105Zm.21-1a.84.84,0,0,0,.2.57.72.72,0,0,0,.52.2.7.7,0,0,0,.49-.2.8.8,0,0,0,.21-.57.78.78,0,0,0-.21-.56.75.75,0,0,0-.49-.21.77.77,0,0,0-.52.21A.82.82,0,0,0,398.05,104.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.4,105.11a.29.29,0,0,1-.58.06,1.29,1.29,0,0,1-.73.23,1.35,1.35,0,0,1,0-2.7,1.28,1.28,0,0,1,.72.23v-1a.3.3,0,0,1,.59,0v2.13h0Zm-1.31-1.82a.72.72,0,0,0-.51.22.8.8,0,0,0-.21.55.77.77,0,0,0,.21.53.72.72,0,0,0,.51.22.7.7,0,0,0,.51-.22.77.77,0,0,0,.21-.53.8.8,0,0,0-.21-.55A.7.7,0,0,0,402.09,103.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.5 85.32 350.38 85.2 361.27 85.15 383.04 85.07 404.81 85.15 415.69 85.2 426.57 85.32 415.69 85.44 404.81 85.48 383.04 85.57 361.27 85.48 350.38 85.44 339.5 85.32",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.86,62.56a7.38,7.38,0,1,0,0,14.74A7.38,7.38,0,1,0,422.86,62.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.17,71.31a6,6,0,0,1-6.31,4.74,6.13,6.13,0,1,1,0-12.24H423a5.88,5.88,0,1,0,.16,11.74A5.81,5.81,0,0,0,429.17,71.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.92,65.42a.27.27,0,0,1,.27.25v.41a3.87,3.87,0,0,1,2,.72c.1.07.16.13.16.24a.28.28,0,0,1-.3.25.3.3,0,0,1-.2-.07,3.36,3.36,0,0,0-1.68-.67v2.88c1.7.33,2.42.91,2.42,1.92s-1,1.85-2.4,1.9v.8a.26.26,0,0,1-.27.24.26.26,0,0,1-.27-.24v-.81a4.45,4.45,0,0,1-2.52-1A.25.25,0,0,1,420,72a.28.28,0,0,1,.28-.25.31.31,0,0,1,.2.07,3.78,3.78,0,0,0,2.19.93V69.85c-1.69-.34-2.38-.91-2.38-1.93s1-1.83,2.35-1.86v-.39A.27.27,0,0,1,422.92,65.42Zm-.24,3.9v-2.8c-1.09,0-1.81.62-1.81,1.36S421.23,69,422.68,69.32Zm.49.63v2.83c1.12,0,1.85-.61,1.85-1.39S424.63,70.25,423.17,70Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,91.12c-9.34,1.68-6.87,15.51,2.48,13.83S427,89.44,417.66,91.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.54,91c-8.9,1.6-6.44,15.43,2.48,13.83S427.45,89.36,418.54,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.42,98.2a5.37,5.37,0,0,1-4.61,5.42c-7.4,1.32-9.45-10.16-2.06-11.48l.14,0C412,93.5,414,104.37,421,103.1A5.13,5.13,0,0,0,425.42,98.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.31,93.64a.24.24,0,0,1,.21.26l0,.39a3.16,3.16,0,0,1,1.65.88.27.27,0,0,1,.11.24.24.24,0,0,1-.28.21.24.24,0,0,1-.17-.09,2.8,2.8,0,0,0-1.38-.8l-.32,2.72c1.44.48,2,1.11,1.89,2.06a1.94,1.94,0,0,1-2.29,1.56l-.09.75a.25.25,0,0,1-.26.21.24.24,0,0,1-.21-.26l.09-.77a3.65,3.65,0,0,1-2.07-1.2.23.23,0,0,1-.09-.21.27.27,0,0,1,.27-.22.24.24,0,0,1,.17.09,3.19,3.19,0,0,0,1.79,1.11l.33-2.77c-1.42-.49-2-1.1-1.85-2.07A1.91,1.91,0,0,1,420,94.21l0-.37A.24.24,0,0,1,420.31,93.64Zm-.65,3.66.32-2.65a1.43,1.43,0,0,0-1.72,1.1C418.18,96.41,418.45,96.85,419.66,97.3ZM420,98l-.31,2.68a1.46,1.46,0,0,0,1.76-1.14C421.54,98.82,421.25,98.38,420,98Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.36,72.35c7.55,1.35,5.56,12.54-2,11.18S403.8,71,411.36,72.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.65,72.22c7.2,1.29,5.2,12.47-2,11.18S403.45,70.93,410.65,72.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.09,78.07a4.34,4.34,0,0,0,3.73,4.38c6,1.07,7.64-8.21,1.66-9.28l-.11,0c5.6,1.12,4,9.91-1.71,8.88A4.13,4.13,0,0,1,405.09,78.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.07,74a.21.21,0,0,1,.16.22l-.06.31a2.55,2.55,0,0,1,1.28.8.24.24,0,0,1,.08.2.21.21,0,0,1-.37.08,2.31,2.31,0,0,0-1.07-.73l-.41,2.18c1.14.47,1.55,1,1.41,1.77A1.56,1.56,0,0,1,409.16,80l-.12.6a.19.19,0,0,1-.22.15.19.19,0,0,1-.15-.22l.12-.61a2.92,2.92,0,0,1-1.61-1.08.21.21,0,0,1-.06-.18.21.21,0,0,1,.23-.16.18.18,0,0,1,.13.08,2.5,2.5,0,0,0,1.39,1l.41-2.21c-1.12-.48-1.52-1-1.38-1.77a1.55,1.55,0,0,1,1.9-1.11l.05-.29A.19.19,0,0,1,410.07,74Zm-.72,2.92.4-2.12a1.14,1.14,0,0,0-1.44.79C408.21,76.11,408.39,76.48,409.35,76.91Zm.26.54-.4,2.14a1.17,1.17,0,0,0,1.48-.82C410.79,78.24,410.58,77.86,409.61,77.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.63,
    y: 132.1,
    width: 34.41,
    height: 12.66,
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.37 144.76 408.3 144.76 411.83 148.34 415.37 144.76",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56,135.64a.27.27,0,0,1,.28.28v.14a2.18,2.18,0,0,1,1,.35.31.31,0,0,1,.19.3.34.34,0,0,1-.35.35.41.41,0,0,1-.19-.05,2.08,2.08,0,0,0-.66-.28V138c1,.24,1.38.63,1.38,1.31s-.54,1.16-1.35,1.24v.38a.27.27,0,0,1-.28.27.28.28,0,0,1-.28-.27v-.39a2.81,2.81,0,0,1-1.3-.5.36.36,0,0,1,.18-.66.4.4,0,0,1,.21.07,2.17,2.17,0,0,0,.94.43v-1.25c-.93-.24-1.36-.59-1.36-1.31a1.28,1.28,0,0,1,1.33-1.22v-.13A.28.28,0,0,1,399.56,135.64Zm-.25,2.17v-1.12c-.41,0-.61.25-.61.53S398.82,137.65,399.31,137.81Zm.5.89v1.16c.41-.05.63-.25.63-.56S400.3,138.85,399.81,138.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,140.15a.34.34,0,0,1-.35.35h-2.26a.32.32,0,0,1-.26-.12.35.35,0,0,1,0-.49l1.89-1.71a.8.8,0,0,0,.27-.61.82.82,0,0,0-.21-.55.81.81,0,0,0-.62-.27.84.84,0,0,0-.55.21l-.2.18a.34.34,0,0,1-.49,0,.35.35,0,0,1,0-.49l.2-.18a1.5,1.5,0,0,1,1-.4,1.55,1.55,0,0,1,1.14.51,1.53,1.53,0,0,1-.11,2.15l-1.2,1.09h1.35A.35.35,0,0,1,404.73,140.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.19,139.6a.47.47,0,1,1,0,.94.47.47,0,0,1,0-.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.08,136.4v3.75a.36.36,0,0,1-.36.35.35.35,0,0,1-.35-.35V137l-.25.14a.32.32,0,0,1-.18.06.36.36,0,0,1-.3-.18.34.34,0,0,1,.12-.48l.78-.46,0,0,0,0h.26l0,0,0,0,0,0s0,0,0,0l0,0,0,0v0s0,0,0,0a0,0,0,0,0,0,0s0,0,0,0a.09.09,0,0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.89,138.27a2.77,2.77,0,0,1,.43-1.52,1.44,1.44,0,0,1,1.19-.71,1.42,1.42,0,0,1,1.17.71,2.9,2.9,0,0,1,0,3,1.44,1.44,0,0,1-1.17.71,1.46,1.46,0,0,1-1.19-.71A2.75,2.75,0,0,1,408.89,138.27Zm2.51,0a2.07,2.07,0,0,0-.3-1.13.74.74,0,0,0-.59-.39.76.76,0,0,0-.61.39,2.07,2.07,0,0,0-.3,1.13,2.1,2.1,0,0,0,.3,1.13.78.78,0,0,0,.61.39.77.77,0,0,0,.59-.39A2.1,2.1,0,0,0,411.4,138.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.22,140.15a.34.34,0,0,1-.35.35h-2.26a.36.36,0,0,1-.27-.12.35.35,0,0,1,0-.49l1.89-1.71a.8.8,0,0,0,.26-.61.82.82,0,0,0-.21-.55.77.77,0,0,0-.61-.27.84.84,0,0,0-.55.21l-.2.18a.34.34,0,0,1-.49,0,.35.35,0,0,1,0-.49l.2-.18a1.5,1.5,0,0,1,1-.4,1.55,1.55,0,0,1,1.14.51,1.53,1.53,0,0,1-.11,2.15l-1.2,1.09h1.35A.35.35,0,0,1,416.22,140.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.18,141.07a.55.55,0,0,0,.43-.57.45.45,0,0,1-.36-.43v0a.41.41,0,0,1,.43-.43c.29,0,.46.22.46.56v.07a1.31,1.31,0,0,1-.31.93,1,1,0,0,1-.6.27.17.17,0,0,1-.2-.18A.17.17,0,0,1,417.18,141.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54,139a1.52,1.52,0,1,1-2.36-1.26,1.05,1.05,0,1,1,1.68,0A1.51,1.51,0,0,1,421.54,139Zm-.69,0a.82.82,0,0,0-.82-.82.83.83,0,1,0,0,1.65A.83.83,0,0,0,420.85,139Zm-1.19-1.89a.36.36,0,0,0,.37.36.36.36,0,1,0-.37-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.67,139a1.55,1.55,0,0,1-1.55,1.54,1.53,1.53,0,0,1-1.53-1.38h0c0-.13,0-.25,0-.37a3.7,3.7,0,0,1,.22-1.3,2.25,2.25,0,0,1,.82-1.09,1.78,1.78,0,0,1,.95-.3.35.35,0,0,1,.37.34.36.36,0,0,1-.34.37,1.06,1.06,0,0,0-.6.18,1.22,1.22,0,0,0-.4.44.89.89,0,0,0-.08.17,1.36,1.36,0,0,1,.61-.13A1.55,1.55,0,0,1,425.67,139Zm-.71,0a.85.85,0,0,0-.84-.84.83.83,0,0,0-.83.84.82.82,0,0,0,.83.83A.84.84,0,0,0,425,139Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,201.09c7.32.55,14.81.7,22.23.67s14.89-.3,22.32-.81,14.84-1.27,22.21-2.28,14.73-2.26,22-3.89a201.85,201.85,0,0,0,42.35-14,143.65,143.65,0,0,0,19.42-11A119.4,119.4,0,0,0,408,155.36l.11.1a120.08,120.08,0,0,1-16.85,14.83A144.56,144.56,0,0,1,372,181.85a203,203,0,0,1-42.36,15.09c-7.29,1.81-14.68,3.24-22.09,4.43s-14.88,2.13-22.36,2.82-15,1.13-22.51,1.34-15,.23-22.62-.16Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,206.21c-4.57,0-8.72-.1-12.68-.31l-.55,0,.4-5.36.54,0c6.51.48,13.57.7,22.19.66,7.36,0,14.86-.3,22.28-.81s14.93-1.28,22.18-2.27c8-1.11,15.22-2.38,22-3.88a202.45,202.45,0,0,0,42.24-13.95,144.37,144.37,0,0,0,19.35-11,121.2,121.2,0,0,0,17-14.32l.37-.38.88.82-.37.4a121.34,121.34,0,0,1-16.92,14.9,145.58,145.58,0,0,1-19.36,11.6,204.39,204.39,0,0,1-42.48,15.13c-6.79,1.69-14,3.14-22.14,4.45-7.32,1.17-14.85,2.12-22.4,2.82s-15.07,1.13-22.54,1.34C259.08,206.16,255.77,206.21,252.66,206.21Zm-12.08-1.35c6.49.31,13.51.36,22,.13,7.44-.2,15-.65,22.48-1.34s15-1.64,22.32-2.81c8.08-1.3,15.29-2.75,22-4.42a203.7,203.7,0,0,0,42.25-15c1.32-.67,2.61-1.34,3.86-2-1.27.64-2.56,1.28-3.9,1.92a203.29,203.29,0,0,1-42.47,14c-6.75,1.51-14,2.79-22,3.89-7.28,1-14.77,1.77-22.26,2.29s-15,.78-22.34.81c-8.43,0-15.35-.17-21.75-.63Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.36 159.16 412.11 150.8 403.99 153.47 410.36 159.16",
    style: {
      fill: "#EE384E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "213.46 321.1 216.38 338.58 236.12 445.21 239.3 445.21 224.94 338.58 222.82 321.1 213.46 321.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.82 321.1 213.46 321.1 216.38 338.58 224.94 338.58 222.82 321.1",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.45 445.21 154.64 445.21 174.38 338.58 177.3 321.1 167.93 321.1 165.81 338.58 151.45 445.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.93 321.1 165.81 338.58 174.38 338.58 177.3 321.1 167.93 321.1",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.23 445.21 95.41 445.21 115.16 338.58 118.07 321.1 108.71 321.1 106.59 338.58 92.23 445.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.59 338.58 115.16 338.58 118.07 321.1 108.71 321.1 106.59 338.58",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.28 329.31 241.96 329.31 241.96 314.07 187.8 314.07 159.6 156.05 82.79 156.05 97.28 329.31",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.89 314.07 241.96 314.07 241.96 329.31 97.35 329.31 97.89 314.07",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.28 329.31 105.16 329.31 90.3 156.05 82.79 156.05 97.28 329.31",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,465.53c-2.81.27-79.42-18-81.84-20.46-.29-.28,1.21-7.24,3.42-16.74l.05-.18c1.38-6,23.69-54.71,23.69-54.71l49.66,13.84-22.56,45.18s9.35,6.74,17.36,13.15l0,0c5,3.94,9.21,7.47,10.12,8.62C238.62,457.24,239.17,465.28,236.36,465.53Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,465.52c-2.81.28-79.42-18-81.84-20.45-.3-.28,1.21-7.24,3.42-16.74l.05-.18c.51-2.24,3.94-10.43,8-19.8,8.18,2.2,37.47,10.11,48.11,13.4l-5.34,10.71s9.34,6.75,17.35,13.15l0,0c4.94,3.94,9.22,7.47,10.12,8.61C238.62,457.24,239.17,465.29,236.36,465.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,465.89c-2.89.25-79.56-18.2-82-20.75-.94-1,.75-13.06,5-25.88l49.41,12s25.24,20,27.66,23.06S239.5,465.64,236.61,465.89Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,462.56c-12.78-3.41-64.62-15.95-77.51-18.35-.11,0-.12.05,0,.08,12.59,3.65,64.54,15.78,77.48,18.48C236.47,462.83,236.52,462.63,236.25,462.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.32,450.34a10.61,10.61,0,0,0-8.44,1.28,10.3,10.3,0,0,0-4.53,6.17c0,.08.13.12.16,0a12.26,12.26,0,0,1,12.77-7.33A.08.08,0,0,0,232.32,450.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,433.48c-5.12-1.31-11.52-.93-15.73,2.5-.17.14,0,.37.2.32a73.21,73.21,0,0,1,15.47-2.17A.33.33,0,0,0,212.65,433.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.25,436c-5.12-1.31-11.53-.93-15.73,2.51-.17.13,0,.36.2.32a73.22,73.22,0,0,1,15.47-2.18A.33.33,0,0,0,216.25,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.85,438.48c-5.13-1.31-11.53-.93-15.74,2.51-.16.13,0,.36.2.32a72.75,72.75,0,0,1,15.48-2.17A.34.34,0,0,0,219.85,438.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.45,441c-5.13-1.31-11.53-.93-15.74,2.5-.16.14,0,.37.2.33a73.4,73.4,0,0,1,15.47-2.18A.33.33,0,0,0,223.45,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,432.79c-5.77-1.37-7.92,7.6-2.13,9S170.74,434.16,165,432.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52,421.09c-2.09-2.79-5.88-1.47-8,.39a27.7,27.7,0,0,0-7.84,12,.14.14,0,0,0,.12.18c0,.4.39.81.83.64,4.27-1.65,9-2.89,12.68-5.8C221.42,426.83,223.49,423.72,221.52,421.09Zm-9,9.41c-2.08.86-4.19,1.62-6.24,2.56a83.76,83.76,0,0,1,4.74-6.92,28.77,28.77,0,0,1,2.71-3c1.53-1.43,7.61-4.51,6.78,1.21C220.09,427.48,215.05,429.47,212.57,430.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.42,432.34c4.31,1.76,9.24,1.6,13.8,2a.65.65,0,0,0,.62-.85c.07,0,.13-.12.06-.21A27.69,27.69,0,0,0,196,423.94c-2.58-1.18-6.59-1.37-7.8,1.89C187,428.91,189.9,431.31,192.42,432.34Zm-2.4-3.68c-2.42-5.25,4.29-4,6.16-3.07a29.08,29.08,0,0,1,3.45,2.13,80.75,80.75,0,0,1,6.5,5.3c-2.23-.32-4.47-.45-6.71-.69C196.75,432,191.35,431.56,190,428.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,426.57l-52.72-14.12S206.78,316.36,203,311.07c-1.87-2.64-51.29-4.87-66.61-18.68-19.91-17.93-5.42-44-5.42-44h55.26s-1,11.53,1.09,13.33c1.39,1.2,67,8.7,73.57,31.11C269,320.32,213.17,426.57,213.17,426.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,418.84a31.84,31.84,0,0,0-4.33-1.64c-1.53-.53-3.06-1.06-4.6-1.57-3-1-6.07-1.94-9.14-2.82-6.16-1.78-12.34-3.52-18.55-5.14-3.24-.84-10.18-2.67-10.61-2.61-.21,0-.26.38-.07.45,6,2.18,12.09,4.05,18.19,5.95s12.17,3.75,18.34,5.35c1.71.44,3.43.83,5.15,1.25a38.78,38.78,0,0,0,5.46,1.2C214.12,419.27,214.29,418.94,214.1,418.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.62,306.77c-1.08-1-2.75-1.14-4.13-1.42l-23.79-4.72c-7.42-1.47-14.88-2.81-22.26-4.46-6.12-1.37-12.32-3.16-17.54-6.65A25.72,25.72,0,0,1,134.47,275c-1.68-5.91-1.63-12.21-.86-18.26.18-1.48.5-2.95.82-4.41a.09.09,0,0,0-.18,0c-2.35,11.26-2.93,24.4,5.29,33.67,4,4.53,9.6,7.28,15.35,9.13,6.48,2.08,13.28,3.18,20,4.5l23.79,4.7c3.82.75,7.7,1.37,11.48,2.28a3.9,3.9,0,0,1,2,1,3,3,0,0,1,.25,2.78c-.44,1.86-1,3.71-1.59,5.53C206,330.57,172.41,400.36,171.5,402a.15.15,0,0,0,.27.14c7.7-12.82,32.76-66.7,38-80.62a90,90,0,0,0,3.46-10.85C213.55,309.31,213.76,307.81,212.62,306.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31,467.45c-2.63,1.05-81.28,5.07-84.29,3.36-.37-.18-.88-7.29-1.42-17l-.4-9.18c-.13-3.1-40.62-48.23-40.62-48.23L301,393l34.53,50.49s10.86,3.85,20.35,7.75l0,0c5.86,2.38,10.95,4.58,12.14,5.42C371.15,458.86,373.93,466.43,371.31,467.45Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.89,431.06c5.87,7,10.26,12.53,10.31,13.55l.4,9.18c.54,9.73,1.06,16.84,1.42,17,3,1.71,81.66-2.31,84.29-3.35s-.16-8.6-3.26-10.81c-1.18-.84-6.27-3-12.12-5.43,0,0,0,0,0,0-9.49-3.89-20.35-7.74-20.35-7.74l-10-14.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.65,467.73c-2.71,1.06-81.47,4.88-84.56,3.13-1.18-.66-2.95-12.74-2.53-26.22l50.78-2.41s29.83,12.08,33,14.37S374.36,466.68,371.65,467.73Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,464.64c-13.22.31-66.51,2.84-79.55,4.16-.11,0-.1.08,0,.08,13.11,0,66.38-3,79.56-4C370.66,464.83,370.65,464.63,370.37,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.16,454a10.57,10.57,0,0,0-7.74,3.61,10.28,10.28,0,0,0-2.61,7.19c0,.08.15.07.16,0a12.27,12.27,0,0,1,10.2-10.63A.08.08,0,0,0,363.16,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,443.35c-5.29.19-11.33,2.35-14.4,6.83-.12.17.13.34.28.25A73.26,73.26,0,0,1,339.67,444,.33.33,0,0,0,339.55,443.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,444.74c-5.29.19-11.33,2.35-14.4,6.83-.12.18.13.34.28.25a73.26,73.26,0,0,1,14.24-6.43A.34.34,0,0,0,343.71,444.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.86,446.14c-5.29.18-11.32,2.34-14.4,6.82-.12.18.13.34.29.26A73.21,73.21,0,0,1,348,446.78.33.33,0,0,0,347.86,446.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,447.53c-5.29.18-11.33,2.34-14.4,6.83-.12.17.13.34.28.25a73.3,73.3,0,0,1,14.24-6.44A.33.33,0,0,0,352,447.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.57,456.1c-5.92.3-5.46,9.52.48,9.21S299.51,455.79,293.57,456.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,429c-2.78-2.08-6,.25-7.58,2.63a27.84,27.84,0,0,0-4.15,13.75c0,.11.09.15.18.14a.64.64,0,0,0,1,.38c3.63-2.79,7.87-5.31,10.54-9.13C346.09,434.51,347.21,431,344.57,429Zm-5.93,11.55c-1.76,1.41-3.57,2.73-5.27,4.21a83.4,83.4,0,0,1,2.59-8,30.63,30.63,0,0,1,1.76-3.65c1.06-1.81,6-6.47,6.84-.75C345,435.51,340.73,438.83,338.64,440.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,447.94c4.64.49,9.32-1.05,13.8-2a.64.64,0,0,0,.35-1c.07-.06.1-.15,0-.22a27.75,27.75,0,0,0-13.1-5.88c-2.81-.4-6.71.54-7,4C313.68,446.17,317.1,447.66,319.81,447.94Zm-3.34-2.85c-3.79-4.36,3-5,5-4.68a31.57,31.57,0,0,1,3.92,1.07,83,83,0,0,1,7.72,3.27c-2.23.32-4.41.82-6.63,1.22C323.88,446.45,318.57,447.49,316.47,445.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,432.9l-63.06,7.71S212.51,366,207.48,361c-15.63-15.4-71.63-42-88.34-66.7-15-22.21.2-45.94.2-45.94h61.57a127.32,127.32,0,0,1-6.27,19.21s51.14,38.51,78.41,66C270.62,351.36,338,432.9,338,432.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,263.69a30.12,30.12,0,0,0-5.26,1.52c-1.79.62-3.55,1.34-5.27,2.11a101.49,101.49,0,0,0-9.9,5.22c-.1.06,0,.2.09.15,3.38-1.63,6.86-3.08,10.35-4.46l5-2a54.78,54.78,0,0,0,5.09-2.07C185.93,264.05,185.83,263.66,185.58,263.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.34,248.4c-.78,2.79-1.49,5.6-2.37,8.36-.41,1.26-.81,2.55-1.33,3.78-.44,1-1.09,2.21-2.31,2.4-1.4.23-1.76-1-1.61-2.12a38.78,38.78,0,0,1,.82-3.82c.33-1.45,2-8.49,2-8.53s0-.13-.06-.21a.11.11,0,0,0-.13,0,61.51,61.51,0,0,0-2.35,6.89l-1.13,4a6.35,6.35,0,0,0-.36,3.11,2.38,2.38,0,0,0,2.15,1.86c0,.09-.11.17-.16.27-.13.27-.23.56-.34.84s-.22.58-.31.87a2.16,2.16,0,0,0-.1.44c0,.16,0,.32,0,.48a.24.24,0,0,0,.44.17,4.56,4.56,0,0,1,.27-.39,1.92,1.92,0,0,0,.21-.46c.11-.28.2-.56.28-.84s.17-.57.23-.85a4.63,4.63,0,0,0,.07-.52,3.21,3.21,0,0,0,1.64-.57,5.42,5.42,0,0,0,1.75-2.51c.46-1.16.83-2.36,1.19-3.55a53.23,53.23,0,0,0,2.06-9A.26.26,0,0,0,182.34,248.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.55,254.19c-.29,1.38-.5,2.79-.86,4.16s-.76,2.68-1.24,4a14.66,14.66,0,0,1-1.82,3.57,13.58,13.58,0,0,1-2.81,2.7,23.27,23.27,0,0,1-6.71,3.47,29.45,29.45,0,0,1-3.69,1,18.68,18.68,0,0,1-2,.28,4.3,4.3,0,0,0-1.59.32.32.32,0,0,0,0,.55,5.76,5.76,0,0,0,2.92.18,20.73,20.73,0,0,0,3.13-.46,22.38,22.38,0,0,0,6-2.3,18.79,18.79,0,0,0,5.05-3.89,13.87,13.87,0,0,0,2.8-5.69,28.32,28.32,0,0,0,1.09-7.81A.14.14,0,0,0,145.55,254.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.09,423.62a39.47,39.47,0,0,0-5.1.2c-1.78.12-3.57.23-5.35.38q-5.26.42-10.5,1c-7,.8-14.07,1.64-21.09,2.6-3.66.51-11.51,1.56-11.92,1.79a.24.24,0,0,0,.11.44c7-.36,14-1,21.05-1.71s14-1.35,21-2.32c1.93-.27,3.85-.59,5.77-.88a46.27,46.27,0,0,0,6.08-1.05C324.29,424,324.33,423.63,324.09,423.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,346.68c3.27,2.1,6.43,4.36,9.6,6.6a91.47,91.47,0,0,1,8.71,6.44,47.88,47.88,0,0,1,3.84,4.09l3.76,4.35q3.77,4.33,7.47,8.74,2.1,2.48,4.18,5c1.44,1.73,2.77,3.55,4.22,5.28.09.11-.06.26-.15.15-2.57-2.89-5.28-5.66-7.84-8.56S217,373,214.45,370s-4.79-5.77-7.38-8.46a60.53,60.53,0,0,0-8.62-6.76c-3.51-2.5-7-5-10.43-7.61C187.73,347,188,346.47,188.32,346.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,268.06c10.51,7.38,21.4,15.63,31.28,23.82s19.68,16.56,29.25,25.15q4,3.6,8,7.3c2.66,2.49,5.26,5.59,7.92,8.07.15.13-.07.34-.22.21-4.8-4.31-9.78-9-14.65-13.24s-9.7-8.4-14.57-12.57q-14.68-12.57-29.73-24.71c-5.56-4.51-12.05-9.07-17.5-13.72C175.2,268.22,175.44,267.92,175.63,268.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,255.67c.59-1.77,1.23-3.53,1.89-5.29,0-.1.2,0,.17.05-2.48,7.33-5,14.82-5.29,22.62a29.49,29.49,0,0,0,1.6,11,28.8,28.8,0,0,0,5.62,9.15c4.9,5.53,11.14,9.89,17,14.3,6.39,4.79,12.91,9.43,19.5,14s13.33,8.83,20.15,13,13.72,7.93,20.51,12a54.51,54.51,0,0,1,9.17,6.81,112.39,112.39,0,0,1,7.94,8.53q8.22,9.39,16.29,18.92,16.17,19,31.73,38.57c1.26,1.6,2.53,3.19,3.8,4.79.06.08-.05.19-.12.11q-16-19.59-32.34-38.9-8.13-9.58-16.34-19.1c-5.24-6.06-10.29-12.49-17-17.05-3.23-2.2-6.67-4.07-10.07-6s-7.06-4.08-10.56-6.18q-10.41-6.27-20.52-13c-6.69-4.47-13.29-9.07-19.76-13.86q-4.86-3.58-9.62-7.29a93.77,93.77,0,0,1-7.92-6.7,35.49,35.49,0,0,1-6.34-8A26.22,26.22,0,0,1,117.6,278C116.8,270.42,118.8,262.8,121.21,255.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24,176.86c10.12,9.28,49.44,36.23,60.59,32.63,8.29-2.67,9.51-12.37,4.82-19.94-4.09-6.58-43.86-17.66-55-20.65C155,166.05,145.3,167.74,155.24,176.86Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.51,198.38l23.15-19.76s-29.47-10.15-42.47-12.09c-13.56-2-17.52,2.52-3.25,13.74C172,191.32,180.51,198.38,180.51,198.38Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,175.48a1.59,1.59,0,0,1-.7.35,1.39,1.39,0,0,1-1.32-.4,1.84,1.84,0,0,0-2-.35,1.8,1.8,0,0,0-.75.66c-.17.26-.36.49-.51.77.27-.16.51-.34.76-.51a1.74,1.74,0,0,1,.7-.38,1.39,1.39,0,0,1,1.32.35,1.87,1.87,0,0,0,2,.42,1.8,1.8,0,0,0,.78-.65c.17-.26.36-.49.51-.77C174.2,175.13,174,175.31,173.7,175.48Zm14.71-1.84h0a1.89,1.89,0,0,0-1.16,1.05,1.77,1.77,0,0,0-.09,1c.06.3.1.6.18.9.08-.3.12-.6.18-.9a1.85,1.85,0,0,1,.25-.75,1.44,1.44,0,0,1,1.22-.64,1.63,1.63,0,0,0,.84-.23Zm-12.68,19c-.07-.3-.1-.61-.19-.91-.08.3-.12.61-.18.91a1.74,1.74,0,0,1-.23.76,1.46,1.46,0,0,1-.33.37l.53.42a1.55,1.55,0,0,0,.33-.55A1.93,1.93,0,0,0,175.73,192.59Zm-23.16-26.28a.43.43,0,0,0,0,.11l0-.12Zm39.47,21a1.85,1.85,0,0,0-1.19-1.69,1.82,1.82,0,0,0-1-.06c-.3.06-.6.09-.9.18.3.08.6.12.9.18a1.84,1.84,0,0,1,.76.23,1.42,1.42,0,0,1,.69,1.18,1.84,1.84,0,0,0,.59,1.37l.5-.43A1.39,1.39,0,0,1,192,187.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,193.06c.49-.53,1.07-1,1.61-1.48l1.67-1.5c1.13-1,2.27-2,3.42-3,2.3-2,4.59-4,6.92-5.89.64-.53,1.28-1.06,1.94-1.57s1.41-1,2.1-1.58c0,0,.08,0,0,.07-.56.5-1.07,1.06-1.62,1.57L193,181.22c-1.14,1-2.29,2-3.45,3-2.27,1.93-4.54,3.87-6.86,5.74l-1.94,1.57c-.68.55-1.34,1.14-2.07,1.63C178.69,193.14,178.63,193.09,178.67,193.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,180.27c14.05,11,22.57,18.1,22.57,18.1l7.4-6.31-38.38-24.29C147.74,169.91,150.06,174.07,157.94,180.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,205.74c-5.63,8.6-15.74.66-17.25-6.36-3.55-16.48-3.2-35.58-2.21-47.55.41-4.89,30.57-6,30.13-.77C230.9,162,230.9,190.85,221.15,205.74Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,179.7c.22,1.28.39,2.56.56,3.84s.31,2.56.46,3.84l.42,3.84c.06.65.14,1.29.22,1.93s.15,1.27.24,1.92a27.67,27.67,0,0,1-.86-3.79c-.23-1.27-.39-2.56-.54-3.84s-.27-2.57-.35-3.86S201.17,181,201.17,179.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,187.62c0,.76,0,1.47-.09,2.2,0,.36-.06.72-.1,1.08a8.48,8.48,0,0,1-.2,1.1,5.78,5.78,0,0,1-.22-2.22,5.84,5.84,0,0,1,.18-1.11A3.69,3.69,0,0,1,202,187.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,132c2,6.09,1.21,20.14-.29,23.45s-25.42,2.77-27.63-.23-7.35-24-5-30.15S229.06,125.73,231.12,132Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.51,135.24c2.57,2.21,3.71-2.09,3.71-2.09s-.14,6.58,3.39,7.84,4.6-4,4.69-4.42c0,.35,0,6.4,3.71,7.3s4.12-4.54,4.13-4.89c.1.33,1.49,4.67,4.44,4.71,5.07.08,1.84-11.13,4-14.64,0,0,6.36,2.94,6.56,3,0,0-2.85-10.73-7.75-13.34a3.54,3.54,0,0,0-4.37.75s-.54-3.56-3.42-4.36c-1.48-.4-3.44,1.6-3.44,1.6a4.44,4.44,0,0,0-3.16-3.38c-2.07-.44-3.72,1.64-3.72,1.64s-1.79-2.48-4.06-2.24C196.62,113.17,191,130.49,196.51,135.24Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,115.24c0-.06,0-.1-.08,0a31.61,31.61,0,0,0-4.74,18.18c0,.21.35.27.38,0A64.71,64.71,0,0,1,205,115.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.13,116.6c0-.07-.08-.12-.12,0-3.31,5.42-5.3,13.09-3.93,20.16,0,.24.33.41.3.13C207.83,132.07,209.84,122,212.13,116.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.41,139.44c-1-6.83.2-13.31,2.43-19.77,0-.09-.09-.12-.13-.06-2,2.87-3,7.14-3.45,10.53a18.17,18.17,0,0,0,.91,9.33C216.21,139.59,216.43,139.58,216.41,139.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.22,133.15a20.27,20.27,0,0,0,.61,3.74,7,7,0,0,0,1.67,3.23,2.28,2.28,0,0,0,1.5.65,3.39,3.39,0,0,0,1.64-.38,4.06,4.06,0,0,0,1.83-2.75l.58-2.73.41,2.76a11.39,11.39,0,0,0,1.08,3.53,4.06,4.06,0,0,0,2.45,2.25,2.31,2.31,0,0,0,2.73-1,6.9,6.9,0,0,0,.87-3.42l.1-3.29,1,3.13a10.92,10.92,0,0,0,1.14,2.48,4.37,4.37,0,0,0,1.85,1.75,2.11,2.11,0,0,0,2.19-.29,4.64,4.64,0,0,0,1.13-2.33,38,38,0,0,0,.6-5.69c.06-1,.12-1.93.22-2.89a7,7,0,0,1,.76-2.8,7.52,7.52,0,0,0-.49,2.82c0,1,0,1.92,0,2.88a31.92,31.92,0,0,1-.31,5.84,5.44,5.44,0,0,1-1.27,2.84,3,3,0,0,1-3.22.56,5.49,5.49,0,0,1-2.35-2.11,12,12,0,0,1-1.31-2.75l1.08-.16a8.14,8.14,0,0,1-1,4.05,3.38,3.38,0,0,1-1.75,1.46,3.79,3.79,0,0,1-2.26.05,5.13,5.13,0,0,1-3.1-2.85,12.47,12.47,0,0,1-1.13-3.9l1,0A4.86,4.86,0,0,1,206,141.1a4.08,4.08,0,0,1-2.06.36,2.9,2.9,0,0,1-1.88-.91A7.08,7.08,0,0,1,200.5,137,17,17,0,0,1,200.22,133.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,151.83s-17.95-20.42-6.53-23.52c3.39-.93,18.43-.67,18.43,2.35,0,3.9-6.28,5-10.34,5,0,0,7.08,6.08,4.32,12.28A6.76,6.76,0,0,1,201.69,151.83Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,128.63a13.91,13.91,0,0,1,4-1,31.87,31.87,0,0,1,4.15-.21,48.5,48.5,0,0,1,8.3.74,7.86,7.86,0,0,1,2.1.7,2.84,2.84,0,0,1,1,.8,1.76,1.76,0,0,1,.33.61,2.35,2.35,0,0,1,.11.68,3.51,3.51,0,0,1-.88,2.26,6.6,6.6,0,0,1-1.79,1.39,12.82,12.82,0,0,1-4.11,1.24,29.61,29.61,0,0,1-4.19.29l.29-.85a16.36,16.36,0,0,1,2.13,2.37,15.31,15.31,0,0,1,1.63,2.72,10.67,10.67,0,0,1,.89,3,8.34,8.34,0,0,1-.17,3.11,9.17,9.17,0,0,0-.16-3.05,11.48,11.48,0,0,0-1.1-2.82,14.74,14.74,0,0,0-1.71-2.5,15.17,15.17,0,0,0-2.12-2.12l-1-.78,1.26-.07a29.9,29.9,0,0,0,4-.41,12.28,12.28,0,0,0,3.74-1.17c1.09-.59,2.08-1.56,2.07-2.62s-1.35-1.46-2.61-1.74a39.92,39.92,0,0,0-4-.67c-1.35-.17-2.71-.33-4.08-.42A26.25,26.25,0,0,0,194.23,128.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.82,259c-1.37,1.93-80,9.28-80.45,8.86-1.19-1.12,3.84-71.54,28.15-100.05,4.29-5,13-4.88,17.3-3.14,2.13.87,10.18,9.84,13.29,18.14S191.67,257.77,190.82,259Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.79,187.2a1.55,1.55,0,0,1-.74-.25,1.4,1.4,0,0,1-.65-1.21,1.81,1.81,0,0,0-2.19-1.76c-.3.06-.61.1-.91.18.3.09.61.12.91.18a1.84,1.84,0,0,1,.76.23,1.4,1.4,0,0,1,.68,1.18,1.86,1.86,0,0,0,1.13,1.72,1.71,1.71,0,0,0,1,.1c.3-.06.6-.1.91-.18C159.39,187.3,159.09,187.27,158.79,187.2Zm13.88,58a1.67,1.67,0,0,1-.74-.26,1.4,1.4,0,0,1-.65-1.21,1.81,1.81,0,0,0-2.19-1.76c-.3.06-.6.1-.91.18.31.09.61.12.91.19a1.59,1.59,0,0,1,.76.23,1.4,1.4,0,0,1,.69,1.17,1.83,1.83,0,0,0,1.13,1.72,1.67,1.67,0,0,0,1,.1c.31-.06.61-.1.91-.18A9.15,9.15,0,0,0,172.67,245.19Zm-40.33-34.7a1.85,1.85,0,0,1-.75-.25A1.44,1.44,0,0,1,131,209a1.85,1.85,0,0,0-1.19-1.69,2,2,0,0,0-1-.07c-.3.07-.6.1-.9.19.3.08.6.12.9.18a1.79,1.79,0,0,1,.77.23,1.38,1.38,0,0,1,.68,1.18,1.87,1.87,0,0,0,1.13,1.72,1.77,1.77,0,0,0,1,.09c.3-.06.6-.09.9-.18C132.94,210.59,132.64,210.55,132.34,210.49Zm33,51.51a1.78,1.78,0,0,0-1-.07c-.3.06-.6.1-.9.18.3.08.6.12.9.18a1.84,1.84,0,0,1,.76.23.88.88,0,0,1,.24.19l.83-.1A1.76,1.76,0,0,0,165.39,262Zm-15-26.22a1.67,1.67,0,0,1-.74-.25,1.41,1.41,0,0,1-.65-1.22,1.85,1.85,0,0,0-1.19-1.69,1.82,1.82,0,0,0-1-.06c-.3.06-.6.09-.9.18.3.08.6.12.9.18a1.84,1.84,0,0,1,.76.23,1.42,1.42,0,0,1,.69,1.18,1.86,1.86,0,0,0,1.13,1.72,1.74,1.74,0,0,0,1,.09,9.15,9.15,0,0,0,.91-.18C151,235.88,150.73,235.84,150.42,235.78ZM118,241.12a1.85,1.85,0,0,1-.75-.25,1.42,1.42,0,0,1-.65-1.22,1.81,1.81,0,0,0-2.19-1.76c-.3.06-.6.1-.9.18.3.09.6.13.9.19a1.59,1.59,0,0,1,.76.23,1.4,1.4,0,0,1,.69,1.17,1.87,1.87,0,0,0,1.13,1.73,1.77,1.77,0,0,0,1,.09c.3-.06.6-.1.9-.18C118.58,241.21,118.28,241.18,118,241.12Zm47.38-29.91a1.8,1.8,0,0,1-.74-.25,1.42,1.42,0,0,1-.65-1.22,1.85,1.85,0,0,0-1.19-1.69,1.93,1.93,0,0,0-1-.07c-.3.07-.61.1-.91.19.3.08.61.12.91.18a1.7,1.7,0,0,1,.76.23,1.38,1.38,0,0,1,.68,1.18,1.87,1.87,0,0,0,1.13,1.72,1.79,1.79,0,0,0,1,.09c.3-.06.61-.1.91-.18C166,211.31,165.66,211.27,165.36,211.21ZM137.9,172.82a1.87,1.87,0,0,1-.7.38,1.43,1.43,0,0,1-1.32-.35,1.77,1.77,0,0,0-.84-.48c-.15.21-.3.41-.43.62a1.29,1.29,0,0,1,.75.4,1.82,1.82,0,0,0,2.8-.31c.17-.26.35-.5.51-.77C138.39,172.47,138.16,172.65,137.9,172.82Zm15-8.95a1.91,1.91,0,0,0-.45.64,1.77,1.77,0,0,0-.09,1c.06.3.1.6.18.9.09-.3.12-.6.18-.9a1.85,1.85,0,0,1,.25-.75,1.42,1.42,0,0,1,1.11-.64C153.75,164,153.36,164,153,163.87ZM148.81,215c-.06-.3-.09-.6-.18-.91-.08.31-.12.61-.18.91a1.84,1.84,0,0,1-.23.76,1.42,1.42,0,0,1-1.18.69,1.84,1.84,0,0,0-1.72,1.13,1.74,1.74,0,0,0-.09,1c.06.3.09.61.18.91.08-.3.12-.61.18-.91a1.67,1.67,0,0,1,.25-.74,1.41,1.41,0,0,1,1.22-.65,1.86,1.86,0,0,0,1.69-1.19A1.82,1.82,0,0,0,148.81,215Zm37.37,39.45a9.18,9.18,0,0,0-.19-.91c-.08.3-.12.6-.18.91a1.62,1.62,0,0,1-.23.76,1.38,1.38,0,0,1-1.17.68,1.89,1.89,0,0,0-1.73,1.13,1.79,1.79,0,0,0-.09,1c.06.3.1.6.18.91.09-.31.12-.61.18-.91a1.8,1.8,0,0,1,.25-.74,1.42,1.42,0,0,1,1.22-.65,1.85,1.85,0,0,0,1.69-1.19A1.93,1.93,0,0,0,186.18,254.4Zm-66.59-37.55c-.06-.31-.1-.61-.18-.91-.09.3-.12.6-.19.91a1.66,1.66,0,0,1-.23.76,1.37,1.37,0,0,1-1.17.68,1.9,1.9,0,0,0-.89.23c-.09.36-.17.72-.25,1.08a1.4,1.4,0,0,1,1.15-.56,1.81,1.81,0,0,0,1.76-2.19Zm17.13-29.5c-.06-.3-.09-.6-.18-.9-.08.3-.12.6-.18.9a1.94,1.94,0,0,1-.23.77,1.38,1.38,0,0,1-1.18.68,1.81,1.81,0,0,0-1.82,2.14c.07.3.1.6.19.9.08-.3.12-.6.18-.9a1.71,1.71,0,0,1,.25-.75,1.42,1.42,0,0,1,1.22-.64,1.8,1.8,0,0,0,1.75-2.2Zm36.11,7.06a1.69,1.69,0,0,0-.6.75,1.79,1.79,0,0,0-.09,1c.06.3.1.6.18.91.08-.31.12-.61.18-.91a1.8,1.8,0,0,1,.25-.74,1.47,1.47,0,0,1,.29-.32Zm-35.77,51.86c-.06-.3-.09-.6-.18-.9-.08.3-.12.6-.18.9a1.7,1.7,0,0,1-.23.76,1.39,1.39,0,0,1-1.18.69,1.87,1.87,0,0,0-1.72,1.13,1.77,1.77,0,0,0-.09,1c.06.3.09.6.18.9.08-.3.12-.6.18-.9a1.71,1.71,0,0,1,.25-.75,1.4,1.4,0,0,1,1.22-.64,1.8,1.8,0,0,0,1.75-2.2Zm12.24-48.68a1.6,1.6,0,0,1-.71.34,1.38,1.38,0,0,1-1.31-.4,1.82,1.82,0,0,0-2.8.31c-.17.26-.35.5-.51.77.28-.15.51-.34.77-.51a1.87,1.87,0,0,1,.7-.38,1.43,1.43,0,0,1,1.32.35,1.87,1.87,0,0,0,2,.42,1.8,1.8,0,0,0,.78-.65c.17-.25.35-.49.51-.76C149.79,197.23,149.56,197.42,149.3,197.59Zm-16.53,32.56a1.74,1.74,0,0,1-.71.35,1.41,1.41,0,0,1-1.31-.41,1.86,1.86,0,0,0-2-.35,1.9,1.9,0,0,0-.76.66c-.17.26-.35.5-.51.77.28-.15.51-.34.77-.51a1.87,1.87,0,0,1,.7-.38,1.43,1.43,0,0,1,1.32.35,1.84,1.84,0,0,0,2,.42,1.88,1.88,0,0,0,.79-.64c.16-.26.35-.5.51-.77A8.56,8.56,0,0,0,132.77,230.15ZM139.91,264a1.59,1.59,0,0,1-.7.35,1.43,1.43,0,0,1-1.32-.4,1.83,1.83,0,0,0-2-.36,1.86,1.86,0,0,0-.76.67c-.17.25-.36.49-.51.76.27-.15.51-.34.77-.51a1.71,1.71,0,0,1,.7-.37,1.35,1.35,0,0,1,1.31.35,1.87,1.87,0,0,0,2,.41,1.72,1.72,0,0,0,.78-.64c.17-.26.36-.5.51-.77C140.41,263.62,140.17,263.81,139.91,264Zm32-37.18a1.71,1.71,0,0,1-.7.35,1.45,1.45,0,0,1-1.32-.4,1.85,1.85,0,0,0-2-.36,1.89,1.89,0,0,0-.75.67c-.17.25-.36.49-.51.76.27-.15.51-.34.76-.51a1.74,1.74,0,0,1,.71-.37,1.37,1.37,0,0,1,1.31.34,1.86,1.86,0,0,0,2,.42,1.72,1.72,0,0,0,.78-.64c.17-.26.36-.5.51-.77C172.4,226.44,172.16,226.63,171.9,226.8Zm-15,23.7a1.49,1.49,0,0,1-.7.35,1.4,1.4,0,0,1-1.32-.4,1.83,1.83,0,0,0-2-.35,1.77,1.77,0,0,0-.76.66c-.17.26-.36.5-.51.77.27-.16.51-.34.77-.51a1.87,1.87,0,0,1,.7-.38,1.43,1.43,0,0,1,1.32.35,1.86,1.86,0,0,0,2,.42,1.8,1.8,0,0,0,.78-.65,8.56,8.56,0,0,0,.51-.77C157.38,250.15,157.14,250.34,156.88,250.5Zm-34.08,4.66a1.49,1.49,0,0,1-.7.35,1.39,1.39,0,0,1-1.32-.4,1.84,1.84,0,0,0-2-.35,1.8,1.8,0,0,0-.75.66c-.17.26-.36.5-.51.77.27-.15.51-.34.76-.51a1.87,1.87,0,0,1,.7-.38,1.41,1.41,0,0,1,1.32.35,1.87,1.87,0,0,0,2,.42,1.8,1.8,0,0,0,.78-.65,8.56,8.56,0,0,0,.51-.77C123.3,254.81,123.06,255,122.8,255.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,179c-10.49,13.48-36.32,54.25-28.06,63.6s61.71,12.12,76.23,6.61c4.32-1.64-9.35-28.85-14.18-29.86-4-.83-30.83-.79-31-1.64-.27-1.49,6.08-19,10-36.34C144.23,162.74,134,169.93,126.93,179Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.77,214.61c10.22.55,12.76,2.26,21.63-1.86,5.82-2.7,10-.14,6,5.16-6.63,8.68-20,10.73-24.79,10.12Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.48,219s12.38-4,23.33-4.52c7.58-.34,24.13.76,36.48,19.71,2.93,4.5,3.92,13-3.53,7.38-5.29-4-7.45-8.11-10.95-9.86,0,0,0,10.94-4.64,13.7a100.49,100.49,0,0,1-12.58,6.35,21.61,21.61,0,0,1-1.4-2.25s-4.56,2.17-11.92,0Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,215.35c3.11,2.47,9.6,7.83,13.39,14.06,4.21,6.93,10.45,21.39,5.31,24.45-3.77,2.24-6.64-3.08-6.64-3.08s1.32,6.53-2.53,7.8c-3.5,1.17-5.47-3.08-5.47-3.08s.12,4.1-3.48,4.57c-4.32.57-3.86-8.11-8.74-11.32C177.84,248,187.09,215.35,187.09,215.35Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.43,232.64c2.54,2.81,6.67,10.67,6.81,18,0,.16-.12.25-.16.1a79.78,79.78,0,0,0-6.72-18.06S192.4,232.61,192.43,232.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,237.09c1.95,2.65,5.84,10.94,5.73,18.37,0,.17-.14.25-.16.1a85.7,85.7,0,0,0-5.63-18.43S185.54,237.06,185.56,237.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,231.68c3,1.59,4.85,3.59,7.22,6a44.3,44.3,0,0,0,3.66,3.46c1.18,1,2.92,2.43,4.54,1.59a2.71,2.71,0,0,0,1.12-2.53,13,13,0,0,0-1.07-4c0-.05.07-.09.09,0a19.25,19.25,0,0,1,1.31,3.66,4.48,4.48,0,0,1-.2,2.59c-.83,1.7-3,1.52-4.38.74a15,15,0,0,1-2.31-1.73c-.7-.61-1.37-1.25-2-1.9-1.34-1.34-2.6-2.76-3.92-4.11a41.46,41.46,0,0,0-4.11-3.61C201.7,231.74,201.77,231.65,201.83,231.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.39,244.41a100.76,100.76,0,0,0-4.65-12.66c0-.06,0-.1.08-.05,2.07,2.88,4.89,10,5.44,12.26s1.12,5,.68,7.23c-.66,3.39-3,3.59-3.9,3.6a4.47,4.47,0,0,1-2.79-1,9,9,0,0,1-2.13-3c0-.06,0-.11.08,0,.91,1.56,2.6,3.26,4.49,3.37a3.14,3.14,0,0,0,2.32-.72,4.08,4.08,0,0,0,1.07-2.62A18.74,18.74,0,0,0,206.39,244.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,210.62,103,207.88s18.18-25.31,27.67-34.41c9.89-9.49,15.75-8.07,10.6,9.33C136.16,199.94,133.29,210.62,133.29,210.62Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51,183.67h0l-.3.37.22,0c.3-.06.6-.1.9-.19C122.05,183.76,121.78,183.72,121.51,183.67Zm10.83,26.82a1.85,1.85,0,0,1-.75-.25A1.44,1.44,0,0,1,131,209a1.85,1.85,0,0,0-1.19-1.69,2,2,0,0,0-1-.07c-.3.07-.6.1-.9.19.3.08.6.12.9.18a1.79,1.79,0,0,1,.77.23,1.38,1.38,0,0,1,.68,1.18,1.88,1.88,0,0,0,.58,1.35l2,.18Zm5.56-37.67a1.87,1.87,0,0,1-.7.38,1.43,1.43,0,0,1-1.32-.35,1.87,1.87,0,0,0-2-.42,1.8,1.8,0,0,0-.78.65c-.17.25-.35.49-.51.77.28-.16.52-.34.77-.51a1.52,1.52,0,0,1,.71-.35,1.38,1.38,0,0,1,1.31.4,1.82,1.82,0,0,0,2.8-.31c.17-.26.35-.5.51-.77C138.39,172.47,138.16,172.65,137.9,172.82Zm-1.18,14.53c-.06-.3-.09-.6-.18-.9-.08.3-.12.6-.18.9a1.94,1.94,0,0,1-.23.77,1.38,1.38,0,0,1-1.18.68,1.81,1.81,0,0,0-1.82,2.14c.07.3.1.6.19.9.08-.3.12-.6.18-.9a1.71,1.71,0,0,1,.25-.75,1.42,1.42,0,0,1,1.22-.64,1.8,1.8,0,0,0,1.75-2.2Zm-16.65,11a1.59,1.59,0,0,1-.7.35,1.4,1.4,0,0,1-1.32-.4,1.83,1.83,0,0,0-2-.35,1.77,1.77,0,0,0-.76.66,8.56,8.56,0,0,0-.51.77c.27-.16.51-.35.77-.51a1.62,1.62,0,0,1,.7-.38,1.35,1.35,0,0,1,1.31.35,1.9,1.9,0,0,0,2,.42,1.8,1.8,0,0,0,.78-.65c.17-.26.36-.49.51-.77C120.57,198,120.33,198.18,120.07,198.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,205.22c-.71-.15-1.45-.2-2.17-.28l-2.23-.26c-1.5-.17-3-.32-4.52-.46-3-.28-6-.58-9.05-.81l-2.49-.17c-.88,0-1.76,0-2.63-.07-.05,0-.05.08,0,.09.74.09,1.48.24,2.23.34s1.53.19,2.29.26c1.51.16,3,.3,4.53.43,3,.26,5.94.53,8.91.72l2.5.15c.87.06,1.75.16,2.62.14A0,0,0,0,0,131.71,205.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86,210.45c.55,0,1.1,0,1.64,0l-.12.09c.42-2,.93-4,1.4-6s1-4,1.59-6c1.12-4,2.3-7.92,3.7-11.8-.8,4.06-1.81,8-2.88,12q-.81,3-1.7,5.95c-.62,2-1.2,3.94-1.89,5.88l0,.1h-.09Q132.67,210.6,131.86,210.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,196.61a14.73,14.73,0,0,1,1.28-3.11,14.22,14.22,0,0,1,1.89-2.74,14,14,0,0,1-1.28,3.11A14.68,14.68,0,0,1,137.46,196.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,178.66c-4.23.74-11-6-13.54-11.39-.17-.36,2.13-14.45,2.3-17.29,0-.58,17.55,5.37,17.55,5.37a45.35,45.35,0,0,0-2.36,10.8C158.92,166.57,159.08,177.94,155,178.66Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,155.35a45.35,45.35,0,0,0-2.36,10.8c0,.13,0,.27,0,.39v.06c0,.23,0,.54,0,.91a9.18,9.18,0,0,1-1.74,0c-9.67-.79-12.23-12.88-12.87-17.51l.53.12.58.15.35.09,1.22.35.53.16c.78.23,1.64.5,2.53.78l.38.12,2.44.78.33.11.74.24.76.25,2.34.77.32.11,1.18.39.27.09,1.24.42.21.07.65.22.12,0,.23.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,127.58c-3.27,5.75-4,24.3-.55,29.27,5.06,7.19,15.35,10.09,22,3.55,6.41-6.34,7-30.54,2.9-35.25C164.38,118.2,150.92,119.1,146.08,127.58Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,142.37c0-.05-.1,0-.1.1,0,1.26-.25,2.69-1.4,3.05a0,0,0,0,0,0,.07C161.24,145.46,161.52,143.56,161.34,142.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28,141c-2-.24-2.34,3.78-.49,4S162,141.22,160.28,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,143.14s.09.07.08.12c-.14,1.24-.1,2.69,1,3.2,0,0,0,.08,0,.07C167.91,146.22,167.87,144.3,168.21,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,141.94c2,0,1.83,4.05,0,4S167.74,141.92,169.43,141.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.85,139a15.24,15.24,0,0,0,1.61-.42,2.67,2.67,0,0,0,1.56-.73.87.87,0,0,0-.05-1,2.14,2.14,0,0,0-2.11-.4,3.15,3.15,0,0,0-1.9,1.19A.91.91,0,0,0,158.85,139Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,140a12.56,12.56,0,0,1-1.56-.55,2.71,2.71,0,0,1-1.49-.86.86.86,0,0,1,.14-1,2.11,2.11,0,0,1,2.13-.21,3.1,3.1,0,0,1,1.79,1.34A.9.9,0,0,1,171.16,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,153.79c.27.32.54.75,1,.82a3,3,0,0,0,1.36-.2s.08,0,.05.07a1.66,1.66,0,0,1-1.64.54,1.31,1.31,0,0,1-.88-1.18C158.73,153.77,158.83,153.75,158.87,153.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,150.17a4.25,4.25,0,0,0,2.67,2.13,5.21,5.21,0,0,0,1.52.2.93.93,0,0,0,.29,0h.28a.33.33,0,0,0,.28-.26h0v-.13h0V152c.11-1,.14-2.42.14-2.42.34.2,2.06,1.16,2.07.66a63.53,63.53,0,0,0-.55-13,.12.12,0,0,0-.23,0c-.26,4,.19,8,0,12.05a7.56,7.56,0,0,0-2-.78c-.14,0,0,2.84-.1,3.26a.18.18,0,0,1,0,.05,5.87,5.87,0,0,1-4.27-1.74C160.54,150,160.43,150.07,160.5,150.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,152a5.12,5.12,0,0,1-2.15,1.39,2.28,2.28,0,0,1-1.39,0c-1-.35-.92-1.26-.67-2a5.86,5.86,0,0,1,.55-1.16A6.53,6.53,0,0,0,164.17,152Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,153.36a2.28,2.28,0,0,1-1.39,0c-1-.35-.92-1.26-.67-2A2.35,2.35,0,0,1,162,153.36Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,144c3.39.2,4-8.07,4-8.07s5.25-.32,8.6-7.07c0,0,6.12,4.94,11.79,4.59,8.88-.55,10-11.87,7-14.55-4.23-3.81-13,0-13,0s-12-4.94-16.72,3a6.42,6.42,0,0,0-6.68,5.66C138.71,133.64,142.25,143.87,144.78,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5,136.77a11.5,11.5,0,0,0,6.92-2.77,8.63,8.63,0,0,0,2.88-7.37.12.12,0,0,1,.23,0c.27,3-.25,5.88-2.36,8.08a8,8,0,0,1-7.68,2.34C147.36,137,147.35,136.78,147.5,136.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,123.93c2-2,4.62-2,7.19-1.6a.12.12,0,0,1,0,.23c-2.51-.59-5.27.8-6.84,2.72s-1.55,4.49-1.29,6.8a18.16,18.16,0,0,0,5.92,11.61.06.06,0,1,1-.07.09A18.16,18.16,0,0,1,138,131.05C137.83,128.63,138,125.74,139.81,123.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,119.25a8.53,8.53,0,0,1,5.21-3.09,10.24,10.24,0,0,1,7.12,1.59,5.78,5.78,0,0,1,2.43,5.24,10.21,10.21,0,0,1-3,6.14c0,.05-.12,0-.08-.06a10.18,10.18,0,0,0,2.47-5.62,5.29,5.29,0,0,0-2.55-5c-3.38-2-8.62-2.37-11.39,1C162.91,119.51,162.73,119.36,162.83,119.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,147.88a5.36,5.36,0,1,1,6.47-5.44h0a5.36,5.36,0,0,1-5.15,5.55A5.24,5.24,0,0,1,158,147.88Zm2.09-9.77a4.4,4.4,0,0,0-1.15-.1,4.64,4.64,0,1,0,1.15.1Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.19,149c-2-.43-3.38-2.87-3.12-5.65a6.43,6.43,0,0,1,1.48-3.62,3.34,3.34,0,0,1,5.69.53,6.42,6.42,0,0,1,.77,3.83c-.28,2.94-2.28,5.16-4.47,5Zm1.56-9.86-.27,0a2.84,2.84,0,0,0-2.39,1.1,5.63,5.63,0,0,0-1.3,3.21c-.24,2.55,1,4.76,2.82,4.93s3.45-1.77,3.69-4.31a5.73,5.73,0,0,0-.68-3.41A3,3,0,0,0,171.75,139.11Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,143l-.41-.59c.87-.6,2.83-1.34,4,.17l-.57.44C166.17,141.7,164.27,143,164.19,143Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,142.17l-.6-.38c.18-.28,1.81-2.75,3.42-2.86s11,1.7,11.38,1.77l-.13.71c-2.72-.52-10-1.84-11.2-1.76S140.75,141.5,140.31,142.17Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,143s-2.86-6.62-5.78-5.71-1.6,9.91,1.25,11.69a3.19,3.19,0,0,0,4.54-.82Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,139.83c-.05,0-.07,0,0,.08,2,1.32,2.71,3.56,3.08,5.8a1.77,1.77,0,0,0-2.49-1c-.07,0,0,.13,0,.13a2,2,0,0,1,2,1.11,9.27,9.27,0,0,1,.66,1.92c.06.22.43.19.4-.05v-.06C145.53,145,144.17,140.71,141.27,139.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,168.29c.51.92.94,1.87,1.5,2.77a30.28,30.28,0,0,0,1.85,2.63,28.68,28.68,0,0,0,4.33,4.48,10.36,10.36,0,0,0,5.88,2.8,5.62,5.62,0,0,0,5.11-2.7c1.46-2.23,1.44-5,1.42-7.65a.08.08,0,1,1,.15,0c.08,2.77.1,5-.92,7.4a6,6,0,0,1-4.4,3.68c-4.73.81-8.62-3.36-11.21-6.75a29.63,29.63,0,0,1-2.09-3.11,23,23,0,0,1-1.77-3.5C139.51,168.26,139.65,168.21,139.69,168.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.73,
    y: 260.2,
    width: 358.54,
    height: 12.75,
    transform: "translate(500 533.14) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.73,
    y: 267.97,
    width: 358.54,
    height: 4.98,
    transform: "translate(500 540.92) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.41 451.85 421.56 451.85 406.56 272.95 393.41 272.95 416.41 451.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.41 272.95 394.95 284.92 407.56 284.92 406.56 272.95 393.41 272.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.59 451.85 78.44 451.85 93.44 272.95 106.59 272.95 83.59 451.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.59 272.95 105.05 284.92 92.44 284.92 93.44 272.95 106.59 272.95",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.25,
    y: 256.69,
    width: 78.05,
    height: 3.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.02,
    y: 256.69,
    width: 39.29,
    height: 3.5,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.25 260.19 302.32 260.19 312.26 208.53 236.19 208.53 226.25 260.19",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63,234.36a4.16,4.16,0,0,0,4.22,4.63,5.16,5.16,0,0,0,5-4.63,4.18,4.18,0,0,0-4.23-4.63A5.14,5.14,0,0,0,264.63,234.36Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.3,354.09c-9.14,12.37-18.66,26.72-21,42.23a.21.21,0,0,0,.41.08,93.74,93.74,0,0,1,4-12.42c6-1.65,11.9-3,15.05-9,3.22-6.12,2.81-14.11,2.2-20.78C403,353.87,402.48,353.85,402.3,354.09Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,383.87c4.11-9.21,9.37-18.45,16.07-26,0,0,.11,0,.07.08a109.76,109.76,0,0,0-11,17.24c3-3.07,6.33-5.82,9.2-9.08,0-.06.14,0,.09.09-2.84,3.42-5.95,7.13-9.66,9.65q-1.49,2.74-3,5.51c.25-.14.51-.26.76-.39,0,0,.09.05,0,.07-.28.14-.56.29-.85.42-.48.87-1,1.74-1.45,2.61C386,384.23,385.77,384.06,385.85,383.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,380.65a54.47,54.47,0,0,0,7-4.68c.06,0,.14,0,.08.09a37.38,37.38,0,0,1-7,4.77A.1.1,0,0,1,388.91,380.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.27,394c0,.19.33.18.33,0,0-5.11,0-10.24.08-15.37,1.31-2.64,4.12-4.1,6.07-6.22a26.94,26.94,0,0,0,3.64-5.07,36.29,36.29,0,0,0,4.23-14.09c.54-5.46-1.53-23.49-3.84-22.87-1.19.33-5.06,9.26-6.08,12.21a85.57,85.57,0,0,0-3.64,15C379.2,369.58,379.35,381.92,380.27,394Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,372l0,0c.28-6.46,1.74-13,3.1-19.26,1.47-6.75,3.19-13.11,6.66-19.13a.1.1,0,0,1,.17.1,71.7,71.7,0,0,0-5.35,14.69c.24-.37.52-.71.76-1.06.1-.13.32,0,.23.14a9.66,9.66,0,0,1-1.09,1.53l0,0c-1.2,4.83-2.06,9.76-2.79,14.69.05-.06.1-.13.16-.19a0,0,0,0,1,.07.06c-.09.16-.19.32-.29.48-.37,2.5-.71,5-1.06,7.47a35.23,35.23,0,0,0,10.4-13.81s.05,0,0,0c-2.1,5.73-5.41,10.83-10.51,14.3-.09.67-.18,1.34-.28,2,0,.14-.24.1-.24,0,0-.59,0-1.18.06-1.77C380.18,372.14,380.15,372.05,380.23,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,362.62A103.41,103.41,0,0,0,391.39,347c0-.06.14,0,.11.05a50.64,50.64,0,0,1-9,15.7C382.42,362.84,382.26,362.72,382.33,362.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85,345.75c1.41-2.5,2.89-4.92,4.22-7.47,0-.07.13,0,.1.07a38.66,38.66,0,0,1-4.11,7.52A.12.12,0,0,1,386.85,345.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.3,346.83s0,0,0,0A0,0,0,1,1,386.3,346.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,379.25a52.26,52.26,0,0,1-1.19,10.06l.15,1.1a47.51,47.51,0,0,0,1.8-11.22.32.32,0,0,0,0-.34h0a74.54,74.54,0,0,0-1.13-15.2c-1.58-9.39-5-18.4-11.58-25.44a.48.48,0,0,0-.73.15c-2.64,6.72-1.72,14.74.53,21.44a39.48,39.48,0,0,0,5.2,10.18C372.12,373.13,375,375.8,376.81,379.25Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.65,341.35c6.21,10.07,10.52,22,11.05,33.9,0,.21-.34.27-.37.05-.15-1.07-.31-2.13-.49-3.18h0a41,41,0,0,1-7-8.13c0-.05,0-.12.09-.07a84.68,84.68,0,0,0,6.84,7.45q-.66-3.94-1.59-7.77c-.17-.19-.33-.39-.49-.58s.07-.31.18-.18l.15.16a88.53,88.53,0,0,0-3.25-10.3c-1.58-1.88-3.34-3.51-4.49-5.78a0,0,0,0,1,.08-.05c.93,1.3,1.82,2.61,2.87,3.81.42.48.88.93,1.31,1.4a78.91,78.91,0,0,0-5.08-10.59A.14.14,0,0,1,365.65,341.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.91,353.77c2,2.7,4.29,5.27,6.15,8.06a.08.08,0,0,1-.13.1,41.21,41.21,0,0,1-6.16-8.08C366.72,353.76,366.85,353.69,366.91,353.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,362.46l.09.08c.06.06,0,.16-.1.1l-.08-.09A.06.06,0,1,1,373.34,362.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.93,360.71a30.85,30.85,0,0,0,6.55,15.36,16.38,16.38,0,0,0,5.31,4.14c2.3,1.14,4.7,2.45,7.08,3.38a46.45,46.45,0,0,1,2.51,8.91c.08-.26.15-.53.23-.78-1.53-13.12-10-24.33-20.87-31.53A.53.53,0,0,0,355.93,360.71Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.68,364.58c-.08-.07,0-.2.11-.14a44.51,44.51,0,0,1,13.84,17.05c.07.18-.17.33-.27.16-.51-.89-1-1.75-1.55-2.59h0c-2.48-.47-4.83-2.21-6.67-3.87-.05,0,0-.12.07-.07a15.84,15.84,0,0,0,3.14,2.2c1,.51,2.1.84,3.15,1.25q-1.38-2.19-2.88-4.21a29,29,0,0,1-7.44-4.19c-.07-.05,0-.17.07-.12a75.42,75.42,0,0,0,6.92,3.7,61.09,61.09,0,0,0-4.89-5.7c-.84-.44-1.69-.89-2.51-1.37-.07,0,0-.15.05-.12a8.6,8.6,0,0,1,1.93.94C361.77,366.51,360.76,365.54,359.68,364.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.91,369.11a3.19,3.19,0,0,1,.42.3s0,.08-.05.07a3.83,3.83,0,0,1-.44-.25C359.77,369.18,359.84,369.06,359.91,369.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.56 420.91 364.8 420.91 367.21 393.82 367.73 387.84 391.63 387.84 392.15 393.82 394.56 420.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.15 393.82 367.21 393.82 367.73 387.84 391.63 387.84 392.15 393.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.31,
    y: 383.66,
    width: 26.74,
    height: 5.91,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.07,56.41c-30.36,0-30.41,43.17,0,43.17S230.47,56.41,200.07,56.41Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,82c-1.62,7.43-7.78,13.87-18.47,13.87-25.23,0-25.19-35.83,0-35.83h.5c-23.71.43-23.6,34.36.46,34.36C210.84,94.45,216.68,88.77,218.53,82Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,82c-1.62,7.43-7.78,13.87-18.47,13.87-25.23,0-25.19-35.83,0-35.83h.5c-23.71.43-23.6,34.36.46,34.36C210.84,94.45,216.68,88.77,218.53,82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.25,64.8a.77.77,0,0,1,.79.72v1.21a11.28,11.28,0,0,1,5.84,2.1c.3.21.46.39.46.69a.81.81,0,0,1-.85.75.84.84,0,0,1-.59-.21,9.85,9.85,0,0,0-4.93-2v8.41c5,1,7.09,2.68,7.09,5.62,0,3.19-2.92,5.44-7,5.56v2.35a.79.79,0,0,1-1.58,0V87.67a12.94,12.94,0,0,1-7.39-2.91.76.76,0,0,1-.36-.63.82.82,0,0,1,.82-.76.88.88,0,0,1,.59.21,11,11,0,0,0,6.4,2.74V77.75c-4.92-1-7-2.64-7-5.64s2.89-5.35,6.9-5.44V65.52A.77.77,0,0,1,200.25,64.8Zm-.73,11.42V68c-3.18.06-5.28,1.8-5.28,4S195.29,75.29,199.52,76.22ZM201,78.06v8.29c3.28-.06,5.42-1.8,5.42-4.09C206.39,80.19,205.24,78.93,201,78.06Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.25,64.8a.77.77,0,0,1,.79.72v1.21a11.28,11.28,0,0,1,5.84,2.1c.3.21.46.39.46.69a.81.81,0,0,1-.85.75.84.84,0,0,1-.59-.21,9.85,9.85,0,0,0-4.93-2v8.41c5,1,7.09,2.68,7.09,5.62,0,3.19-2.92,5.44-7,5.56v2.35a.79.79,0,0,1-1.58,0V87.67a12.94,12.94,0,0,1-7.39-2.91.76.76,0,0,1-.36-.63.82.82,0,0,1,.82-.76.88.88,0,0,1,.59.21,11,11,0,0,0,6.4,2.74V77.75c-4.92-1-7-2.64-7-5.64s2.89-5.35,6.9-5.44V65.52A.77.77,0,0,1,200.25,64.8Zm-.73,11.42V68c-3.18.06-5.28,1.8-5.28,4S195.29,75.29,199.52,76.22ZM201,78.06v8.29c3.28-.06,5.42-1.8,5.42-4.09C206.39,80.19,205.24,78.93,201,78.06Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M446.73,164c-27.33,4.9-20.11,45.4,7.27,40.48S474.11,159.1,446.73,164Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.73,164c-27.33,4.9-20.11,45.4,7.27,40.48S474.11,159.1,446.73,164Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.3,163.55c-26.05,4.67-18.83,45.17,7.26,40.48S475.39,158.87,449.3,163.55Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.45,184.74c-.14,7.22-4.34,14.21-13.51,15.85-21.65,3.89-27.65-29.72-6-33.6l.43-.07c-20.27,4.06-14.46,35.87,6.18,32.16A15,15,0,0,0,469.45,184.74Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.45,184.74c-.14,7.22-4.34,14.21-13.51,15.85-21.65,3.89-27.65-29.72-6-33.6l.43-.07c-20.27,4.06-14.46,35.87,6.18,32.16A15,15,0,0,0,469.45,184.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5,171.38a.69.69,0,0,1,.6.76l-.13,1.14a9.37,9.37,0,0,1,4.83,2.58.81.81,0,0,1,.32.7.75.75,0,0,1-.83.63.72.72,0,0,1-.49-.26,8.12,8.12,0,0,0-4-2.35l-.94,8c4.22,1.42,5.85,3.25,5.52,6-.36,3-3.14,4.85-6.71,4.55l-.26,2.21a.68.68,0,1,1-1.36-.16l.26-2.24a10.76,10.76,0,0,1-6.07-3.51.72.72,0,0,1,.55-1.27.78.78,0,0,1,.49.26,9.19,9.19,0,0,0,5.24,3.24l.95-8.1c-4.15-1.44-5.73-3.21-5.4-6.06s3.1-4.76,6.58-4.44l.13-1.08A.69.69,0,0,1,454.5,171.38Zm-1.9,10.73.92-7.76c-2.77-.27-4.78,1.16-5,3.21S449,180.8,452.6,182.11Zm1,1.88-.92,7.85c2.85.28,4.89-1.16,5.14-3.32C458.1,186.56,457.25,185.25,453.65,184Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5,171.38a.69.69,0,0,1,.6.76l-.13,1.14a9.37,9.37,0,0,1,4.83,2.58.81.81,0,0,1,.32.7.75.75,0,0,1-.83.63.72.72,0,0,1-.49-.26,8.12,8.12,0,0,0-4-2.35l-.94,8c4.22,1.42,5.85,3.25,5.52,6-.36,3-3.14,4.85-6.71,4.55l-.26,2.21a.68.68,0,1,1-1.36-.16l.26-2.24a10.76,10.76,0,0,1-6.07-3.51.72.72,0,0,1,.55-1.27.78.78,0,0,1,.49.26,9.19,9.19,0,0,0,5.24,3.24l.95-8.1c-4.15-1.44-5.73-3.21-5.4-6.06s3.1-4.76,6.58-4.44l.13-1.08A.69.69,0,0,1,454.5,171.38Zm-1.9,10.73.92-7.76c-2.77-.27-4.78,1.16-5,3.21S449,180.8,452.6,182.11Zm1,1.88-.92,7.85c2.85.28,4.89-1.16,5.14-3.32C458.1,186.56,457.25,185.25,453.65,184Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M425.82,206.13c22.1,4,16.27,36.71-5.87,32.74S403.69,202.16,425.82,206.13Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.82,206.13c22.1,4,16.27,36.71-5.87,32.74S403.69,202.16,425.82,206.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.75,205.76c21.06,3.78,15.22,36.52-5.87,32.73S402.65,202,423.75,205.76Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.46,222.9c.11,5.83,3.5,11.48,10.92,12.81,17.5,3.14,22.35-24,4.87-27.17l-.34,0c16.39,3.28,11.69,29-5,26A12.15,12.15,0,0,1,407.46,222.9Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.46,222.9c.11,5.83,3.5,11.48,10.92,12.81,17.5,3.14,22.35-24,4.87-27.17l-.34,0c16.39,3.28,11.69,29-5,26A12.15,12.15,0,0,1,407.46,222.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,210.93a.56.56,0,0,1,.44.65l-.16.91a7.54,7.54,0,0,1,3.75,2.35.65.65,0,0,1,.22.58.59.59,0,0,1-.7.46.61.61,0,0,1-.38-.24,6.58,6.58,0,0,0-3.14-2.11l-1.18,6.37c3.32,1.37,4.54,2.94,4.12,5.17-.45,2.41-2.79,3.74-5.65,3.3l-.33,1.78a.56.56,0,0,1-1.1-.2l.34-1.8a8.73,8.73,0,0,1-4.71-3.16.59.59,0,0,1-.16-.53.6.6,0,0,1,.67-.46.56.56,0,0,1,.38.23,7.44,7.44,0,0,0,4.05,2.9l1.21-6.48c-3.27-1.39-4.45-2.91-4-5.18s2.76-3.68,5.55-3.23l.16-.86A.57.57,0,0,1,422.05,210.93Zm-2.11,8.56,1.16-6.22c-2.22-.36-3.92.69-4.23,2.32S417.13,218.23,419.94,219.49Zm.74,1.57-1.17,6.28c2.29.38,4-.66,4.33-2.39C424.14,223.38,423.52,222.27,420.68,221.06Z",
    style: {
      fill: "#EE384E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M422.05,210.93a.56.56,0,0,1,.44.65l-.16.91a7.54,7.54,0,0,1,3.75,2.35.65.65,0,0,1,.22.58.59.59,0,0,1-.7.46.61.61,0,0,1-.38-.24,6.58,6.58,0,0,0-3.14-2.11l-1.18,6.37c3.32,1.37,4.54,2.94,4.12,5.17-.45,2.41-2.79,3.74-5.65,3.3l-.33,1.78a.56.56,0,0,1-1.1-.2l.34-1.8a8.73,8.73,0,0,1-4.71-3.16.59.59,0,0,1-.16-.53.6.6,0,0,1,.67-.46.56.56,0,0,1,.38.23,7.44,7.44,0,0,0,4.05,2.9l1.21-6.48c-3.27-1.39-4.45-2.91-4-5.18s2.76-3.68,5.55-3.23l.16-.86A.57.57,0,0,1,422.05,210.93Zm-2.11,8.56,1.16-6.22c-2.22-.36-3.92.69-4.23,2.32S417.13,218.23,419.94,219.49Zm.74,1.57-1.17,6.28c2.29.38,4-.66,4.33-2.39C424.14,223.38,423.52,222.27,420.68,221.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueCuate);
export default __webpack_public_path__ + "static/media/Revenue-cuate.86ac51593ee251c24d99c2b0ddf39a6f.svg";
export { ForwardRef as ReactComponent };